export const translations = {
  es: {
    // Navigation
    'nav.home': 'Inicio',
    'nav.boats': 'Barcos',
    'nav.premium': 'Yates Premium',
    'nav.jetski': 'Motos Acuáticas',
    'nav.licenses': 'Licencias',
    'nav.howItWorks': 'Cómo Funciona',
    'nav.gallery': 'Galería',
    'nav.reviews': 'Reseñas',
    'nav.contact': 'Contacto',

    // Header
    'header.tagline': 'Torrevieja · Alquiler de Barcos',
    'header.reserve': 'Reservar por WhatsApp',

    // Hero
    'hero.headline':
      'Alquila tu barco en Torrevieja y vive el mejor día del verano',
    'hero.subheadline':
      'Barcos con y sin licencia, motos acuáticas y experiencias premium en el Mediterráneo. Reserva fácil por WhatsApp en minutos.',
    'hero.cta.primary': 'Ver barcos disponibles',
    'hero.cta.secondary': 'Reservar por WhatsApp',
    'hero.trust.1': 'Sin carrito ni pago online',
    'hero.trust.2': 'Respuesta inmediata',
    'hero.trust.3': 'Con y sin licencia',
    'hero.trust.4': 'Torrevieja · Costa Blanca',

    // Trust Bar
    'trustbar.1': '13 embarcaciones disponibles',
    'trustbar.2': 'Salidas desde Torrevieja',
    'trustbar.3': 'Reserva rápida por WhatsApp',
    'trustbar.4': 'Experiencias para todos los niveles',

    // Quiz
    'quiz.title': 'Encuentra tu barco ideal',
    'quiz.subtitle': 'Responde 4 preguntas y te recomendamos la mejor opción',
    'quiz.q1': '¿Cuántas personas sois?',
    'quiz.q1.o1': '1 a 4 personas',
    'quiz.q1.o2': '5 a 6 personas',
    'quiz.q1.o3': '7 a 8 personas',
    'quiz.q1.o4': '9 a 12 personas',
    'quiz.q2': '¿Tienes licencia náutica?',
    'quiz.q2.o1': 'Sí tengo licencia',
    'quiz.q2.o2': 'No tengo licencia',
    'quiz.q2.o3': 'Quiero sacarme la licencia',
    'quiz.q3': '¿Qué experiencia buscas?',
    'quiz.q3.o1': 'Solo quiero un barco',
    'quiz.q3.o2': 'Barco + moto acuática',
    'quiz.q3.o3': 'Solo moto acuática',
    'quiz.q3.o4': 'Sorpréndeme',
    'quiz.q4': '¿Cuál es tu presupuesto?',
    'quiz.q4.o1': 'Hasta 150€',
    'quiz.q4.o2': 'Entre 150€ y 300€',
    'quiz.q4.o3': 'Entre 300€ y 500€',
    'quiz.q4.o4': 'Más de 500€',
    'quiz.result.title': 'Tu opción ideal',
    'quiz.result.cta': 'Reservar esta opción por WhatsApp',
    'quiz.result.from': 'Desde',
    'quiz.reset': 'Volver a empezar',

    // Fleet
    'fleet.title': 'Nuestra flota en Torrevieja',
    'fleet.filter.all': 'Todos',
    'fleet.filter.noLicense': 'Sin Licencia',
    'fleet.filter.license': 'Con Licencia',
    'fleet.filter.premium': 'Premium con Patrón',

    // Boat Card
    'boat.capacity': 'Capacidad',
    'boat.license': 'Licencia',
    'boat.location': 'Ubicación',
    'boat.engine': 'Motor',
    'boat.length': 'Eslora',
    'boat.price.from': 'Desde',
    'boat.price.lowSeason': 'Temporada Baja (nov-mar)',
    'boat.price.highSeason': 'Temporada Alta (abr-oct)',
    'boat.price.allYear': 'Todo el año',
    'boat.price.hour': 'hora',
    'boat.price.hours': 'horas',
    'boat.price.halfDay': 'Medio día',
    'boat.price.fullDay': 'Día completo',
    'boat.price.sunset': 'Atardecer 2 horas',
    'boat.note.fuel': '⚠️ Combustible no incluido',
    'boat.note.highSeason': '⚠️ Tarifas temporada alta',
    'boat.note.skipperFuel': '⚠️ Patrón y combustible no incluidos',
    'boat.cta': 'Reservar por WhatsApp',
    'boat.banner.licenseReq': 'REQUIERE LICENCIA DE NAVEGACIÓN',
    'boat.banner.noLicense': 'SIN LICENCIA DE NAVEGACIÓN',
    'boat.banner.licenseSkipper': 'REQUIERE LICENCIA · PATRÓN +20€/H',
    'boat.banner.licensePNBSkipper': 'REQUIERE LICENCIA PNB · PATRÓN +20€/H',
    'boat.banner.skipperIncluded': 'PATRÓN INCLUIDO',
    'boat.spec.peopleMax': 'PERSONAS MAX',
    'boat.spec.length': 'METROS ESLORA',
    'boat.duration.2h': '2 HORAS',
    'boat.duration.4h': '4 HORAS',
    'boat.duration.8h': '8 HORAS',
    'boat.duration.halfDay': 'MEDIO DÍA',
    'boat.duration.fullDay': 'DÍA COMPLETO',
    'boat.durationInfo': 'Medio día = 4h · Día completo = 8h',
    'boat.specLines.searay.peopleSkipper': '11 PERSONAS + PATRÓN',
    'boat.specLines.searay.paddleIncluded': 'TABLA PADDLE SURF INCLUIDA',
    'boat.specLines.prestige.people': '12 PERSONAS + PATRÓN',
    'boat.specLines.prestige.features': '2 CAMAROTES · SALÓN · COCINA',

    // Equipment Translations
    'eq.solarium': 'Solárium',
    'eq.solariumProa': 'Solárium en proa',
    'eq.solariumPopa': 'Solárium en popa',
    'eq.toldo': 'Toldo bimini',
    'eq.toldoGran': 'Gran toldo',
    'eq.radio': 'Radio Bluetooth',
    'eq.nevera': 'Nevera con hielo',
    'eq.escalera': 'Escalera de baño',
    'eq.asientos': 'Asientos acolchados',
    'eq.asientosPopa': 'Asientos de popa ajustables',
    'eq.mesa': 'Mesa',
    'eq.ducha': 'Ducha',
    'eq.sonda': 'Sonda',
    'eq.gps': 'Plotter GPS',
    'eq.camarote': 'Camarote',
    'eq.baño': 'Baño completo',
    'eq.cocina': 'Cocina equipada',
    'eq.paddle': 'Paddle surf incluido',
    'eq.musica': 'Equipo de música',
    'eq.plataforma': 'Plataforma de baño',
    'eq.radar': 'Radar',
    'eq.piloto': 'Piloto automático',
    'eq.helice': 'Hélice de proa',
    'eq.molinete': 'Molinete eléctrico',
    'eq.salon': 'Salón convertible',
    'eq.banera': 'Bañera de teca',

    // Boat Descriptions
    'desc.marinello':
      'Navega por la costa de Torrevieja sin necesidad de licencia. Perfecto para familias y grupos que quieren libertad total.',
    'desc.v2':
      'Explora el Mediterráneo con comodidad y libertad. Disponible en Torrevieja y Cabo Roig.',
    'desc.compass':
      'Ideal para quienes quieren una experiencia fácil, cómoda y sin complicaciones.',
    'desc.calima':
      'Perfecto para parejas o grupos pequeños que quieren disfrutar del mar a su ritmo.',
    'desc.marinelloMartin':
      'Un clásico cómodo y funcional para disfrutar Torrevieja sin licencia.',
    'desc.marinelloNoa':
      'Libertad total para navegar y disfrutar Torrevieja de forma sencilla.',
    'desc.invictus':
      'Potencia, confort y espacio para grupos que quieren algo más.',
    'desc.commander':
      'Ideal para explorar la costa alicantina con libertad y estilo. Llega hasta la Isla de Tabarca.',
    'desc.quicksilver':
      'Espacioso, potente y perfecto para pasar un gran día en el agua.',
    'desc.flyer':
      'Una opción más completa para excursiones largas y experiencias premium.',
    'desc.prestige':
      'Perfecto para grupos grandes, celebraciones y atardeceres mediterráneos inolvidables.',
    'desc.searay':
      'Una experiencia premium para grupos que quieren comodidad, música y el mejor mar.',
    'desc.noamar':
      'La experiencia más premium del puerto de Torrevieja. 14 metros de lujo mediterráneo.',
    'desc.nireus':
      'Embarcación deportiva potente con motor de 200 CV. Ideal para grupos de hasta 12 personas que buscan velocidad y diversión sin necesidad de licencia.',
    'desc.ranieri':
      'Con 7,8 metros y un motor de 225 CV, la Ranieri ofrece una navegación excepcional y un solárium de proa inmenso para disfrutar del sol de Torrevieja.',
    'desc.smiler':
      'Ágil y divertida, la Smiler es perfecta para grupos de hasta 8 personas. Sus 115 CV garantizan una experiencia emocionante en el mar.',
    'boat.badge.licencia': 'licencia',
    'boat.badge.max': 'max',
    'boat.badge.metros': 'metros',
    'boat.badge.motor': 'motor',

    // Jet Ski
    'jetski.title': 'Motos Acuáticas en Torrevieja',
    'jetski.subtitle': 'Adrenalina pura en el Mediterráneo',
    'jetski.desc':
      'Si buscas velocidad, emoción y diversión en el mar, las motos acuáticas son tu opción. Disponibles en Torrevieja con briefing de seguridad incluido. Sin licencia requerida. Excursiones libres o guiadas según disponibilidad.',
    'jetski.f1': 'Sin licencia necesaria',
    'jetski.f2': 'Briefing de seguridad incluido',
    'jetski.f3': 'Motos acuáticas modernas',
    'jetski.f4': 'Opciones libres o guiadas',
    'jetski.f5': 'Hasta 10 millas de costa',
    'jetski.f6': 'Perfectas para el verano',
    'jetski.note': 'Consultar disponibilidad y precio por WhatsApp',
    'jetski.cta': 'Reservar moto acuática',

    // Licenses
    'license.title': '¿No tienes licencia? Te ayudamos a conseguirla',
    'license.desc':
      'Kevin Boats también te orienta si quieres obtener tu licencia náutica para navegar con libertad total. Accede a barcos más potentes y abre nuevas experiencias en el mar. Cuéntanos tu situación y te ayudamos a elegir la licencia que necesitas.',
    'license.f1': 'Orientación personalizada',
    'license.f2': 'Proceso sencillo y rápido',
    'license.f3': 'Accede a más embarcaciones',
    'license.f4': 'Amplía tus opciones en el mar',
    'license.cta': 'Quiero información sobre licencias',

    // How it works
    'hiw.title': 'Reservar es muy fácil',
    'hiw.s1.title': 'Elige tu barco',
    'hiw.s1.desc':
      'Explora el catálogo y encuentra la opción perfecta para tu grupo y presupuesto.',
    'hiw.s2.title': 'Escríbenos por WhatsApp',
    'hiw.s2.desc':
      'Cuéntanos la fecha, cuántas personas sois y si tienes licencia.',
    'hiw.s3.title': 'Confirma y reserva',
    'hiw.s3.desc':
      'Kevin confirma disponibilidad y acordáis todos los detalles. ¡A navegar!',
    'hiw.cta': 'Empezar ahora',

    // Why Us
    'why.title': '¿Por qué elegir Kevin Boats?',
    'why.c1.title': 'Trato cercano',
    'why.c1.desc':
      'Hablas directamente con Kevin. Sin intermediarios, sin formularios.',
    'why.c2.title': 'Conocemos Torrevieja',
    'why.c2.desc':
      'Locales de verdad. Sabemos cuáles son los mejores rincones.',
    'why.c3.title': 'Con y sin licencia',
    'why.c3.desc':
      'Opciones para todos. ¿Tienes licencia o no? Tenemos tu barco.',
    'why.c4.title': 'Respuesta inmediata',
    'why.c4.desc': 'Por WhatsApp confirmamos disponibilidad en minutos.',
    'why.c5.title': 'Flota variada',
    'why.c5.desc':
      '13 embarcaciones para parejas, familias, grupos y celebraciones.',
    'why.c6.title': 'Te ayudamos con licencias',
    'why.c6.desc': 'Si quieres sacar tu licencia náutica, te orientamos.',

    // Gallery
    'gallery.title': 'Vive el Mediterráneo como nunca antes',
    'gallery.subtitle': 'Torrevieja · Costa Blanca · Tabarca · Cabo Roig',

    // Final CTA
    'final.title': '¿Listo para vivir el mejor día del verano?',
    'final.desc':
      'Cuéntanos cuántas personas sois, qué fecha tienes en mente y si tienes licencia. Kevin te encuentra el barco perfecto en minutos.',
    'final.cta.primary': 'Hablar con Kevin por WhatsApp',
    'final.cta.secondary': 'Ver catálogo completo',

    // Contact
    'contact.title': 'Contacto',
    'contact.location': 'Torrevieja, España',
    'contact.whatsapp': 'Reservas por WhatsApp',
    'contact.instagram': 'Instagram: @kevin.boats',
    'contact.response': 'Respuesta rápida garantizada',
    'contact.cta': 'Escribir por WhatsApp',

    // Footer
    'footer.desc': 'Alquiler de barcos y motos acuáticas',
    'footer.links': 'Enlaces rápidos',
    'footer.contact': 'Contacto',
    'footer.rights': 'Todos los derechos reservados',
    'footer.legal': 'Legal',
    'footer.cookies': 'Política de Cookies',
    'footer.privacy': 'Política de Privacidad',
    'footer.terms': 'Términos y Condiciones',
    'footer.dataProtection': 'Protección de Datos',
    'footer.credit': 'Diseño y desarrollo por',
    'legal.title': 'Información Legal',
    'legal.close': 'Cerrar',
    'legal.cookies.title': 'Política de Cookies',
    'legal.cookies.body':
      'Este sitio web utiliza cookies propias y de terceros para mejorar tu experiencia de navegación, analizar el uso del sitio y personalizar el contenido. Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo al visitar el sitio. Puedes configurar o rechazar el uso de cookies en cualquier momento a través de la configuración de tu navegador. Al continuar navegando por este sitio, aceptas el uso de cookies según lo descrito en esta política.',
    'legal.privacy.title': 'Política de Privacidad',
    'legal.privacy.body':
      'En Kevin Boats respetamos tu privacidad y nos comprometemos a proteger los datos personales que compartes con nosotros. Los datos recogidos a través de WhatsApp o cualquier otro canal de comunicación se utilizan únicamente para gestionar tu reserva y responder a tus consultas. No compartimos tus datos con terceros sin tu consentimiento expreso. Tienes derecho a acceder, rectificar y eliminar tus datos personales en cualquier momento contactándonos directamente.',
    'legal.terms.title': 'Términos y Condiciones',
    'legal.terms.body':
      'El alquiler de embarcaciones está sujeto a disponibilidad y condiciones meteorológicas. El cliente debe presentar documentación válida y, en su caso, la licencia náutica correspondiente. Kevin Boats se reserva el derecho de cancelar la reserva por motivos de seguridad. El uso indebido de las embarcaciones puede acarrear responsabilidades legales. Todas las reservas se gestionan directamente por WhatsApp y se confirman bajo acuerdo mutuo.',
    'legal.dataProtection.title': 'Protección de Datos (RGPD)',
    'legal.dataProtection.body':
      'De acuerdo con el Reglamento General de Protección de Datos (RGPD) UE 2016/679, te informamos que los datos personales facilitados serán tratados de forma confidencial. Responsable del tratamiento: Kevin Boats, Torrevieja, España. Finalidad: gestión de reservas y comunicación comercial. Legitimación: consentimiento del interesado. Derechos: acceso, rectificación, supresión, oposición, limitación y portabilidad de los datos contactando con nosotros por WhatsApp.',
    'cookieBanner.text':
      'Usamos cookies para mejorar tu experiencia de navegación. Al continuar, aceptas nuestra política de cookies.',
    'cookieBanner.accept': 'Aceptar',
    'cookieBanner.reject': 'Rechazar',

    // WhatsApp Templates
    'wa.general':
      'Hola Kevin 👋\nMe interesa reservar [BARCO]\nFecha: [FECHA]\nPersonas: [NÚMERO]\nTengo licencia: [SÍ/NO]\nPresupuesto: [PRESUPUESTO]\n¿Está disponible?',
    'wa.jetski':
      'Hola Kevin 👋\nMe interesan las motos acuáticas en Torrevieja.\nFecha: [FECHA]\nPersonas: [NÚMERO]\n¿Cuál es el precio y la disponibilidad?',
    'wa.license':
      'Hola Kevin 👋\nMe interesa información sobre licencias náuticas.\n¿Me puedes orientar?',
    'wa.help':
      'Hola Kevin, me interesa reservar un barco en Torrevieja. ¿Me puedes ayudar?',
    'wa.premium':
      'Hola Kevin 👋\nMe interesa reservar [BARCO].\nFecha: [FECHA]\nPersonas: [NÚMERO]\nDuración: [4H o 8H]\n¿Está disponible y cuál es el precio final?',
    'wa.searay':
      'Hola Kevin 👋 Me interesa reservar el Sea Ray 290 Sundeck con patrón. ¿Está disponible?',

    // Premium Fleet
    'premium.badge': 'PATRÓN PROFESIONAL INCLUIDO',
    'premium.title': 'YATES PREMIUM',
    'premium.subtitle': 'Tú solo disfruta — el capitán se ocupa de todo',
    'premium.description':
      'Para grupos grandes, celebraciones especiales y experiencias de lujo en el Mediterráneo. Sin necesidad de licencia.',
    'premium.captain': 'CON',
    'premium.captainLabel': 'capitán',
    'premium.max': 'max',
    'premium.meters': 'metros',
    'premium.reserve': 'RESERVAR',
    'premium.price': 'PRECIO',
    'premium.boat.monaco.desc':
      'Embarcación premium de gran formato con patrón incluido. Perfecta para grupos que buscan comodidad y exclusividad.',
    'premium.boat.diamonte.desc':
      'Embarcación premium con patrón incluido. Perfecta para grupos que buscan comodidad y exclusividad en el Mediterráneo.',
    'premium.boat.lagoon.desc':
      'Catamarán de lujo de última generación. Combina estilo y funcionalidad para una experiencia premium en el Mediterráneo.',
    'premium.boat.lagoon.note': '+ gasolina no incluida',
    'premium.boat.prestige.desc':
      'Yate premium con 2 camarotes, salón y cocina. Patrón profesional incluido para hasta 12 personas.',
    'premium.boat.prestige.note': '2 camarotes · Salón · Cocina',
    'premium.boat.puravida.desc':
      'El catamarán más exclusivo de la flota Kevin Boats. 15 metros de puro lujo mediterráneo con capitán profesional incluido. La experiencia definitiva en Torrevieja.',
    'premium.boat.puravida.badge': 'EXPERIENCIA PREMIUM',
    'premium.boat.nireus.desc':
      'Embarcación potente y espaciosa de 6 metros, ideal para grupos de hasta 12 personas que buscan velocidad y confort con patrón profesional.',
    'premium.aria.prev': 'Foto anterior',
    'premium.aria.next': 'Foto siguiente',
    'premium.aria.zoom': 'Ampliar foto',
    'premium.aria.close': 'Cerrar',

    // Jet Ski Tours
    'jetski.tour.badge': 'SIN LICENCIA NECESARIA',
    'jetski.tour.title': 'MOTOS ACUÁTICAS\nEN TORREVIEJA',
    'jetski.tour.subtitle': 'Adrenalina pura en el Mediterráneo',
    'jetski.tour.f1': 'Sin licencia necesaria',
    'jetski.tour.f2': '5 rutas disponibles',
    'jetski.tour.f3': 'Briefing incluido',
    'jetski.tour.f4': 'Salida desde Torrevieja',
    'jetski.tour.1.name': 'LAS PLAYAS',
    'jetski.tour.1.desc':
      'Recorre las playas más bonitas de Torrevieja. Perfecto para empezar.',
    'jetski.tour.2.name': 'LAS CALAS',
    'jetski.tour.2.desc':
      'Descubre las calas secretas de la Costa Blanca. Aguas cristalinas garantizadas.',
    'jetski.tour.3.name': 'CABO ROIG',
    'jetski.tour.3.desc':
      'Navega hasta Cabo Roig y disfruta de las vistas más espectaculares de la costa.',
    'jetski.tour.4.name': 'AGUAMARINA',
    'jetski.tour.4.desc':
      'Ruta extendida hasta Aguamarina. Navegación libre por las mejores calas de la Costa Blanca.',
    'jetski.tour.5.name': 'TABARCA / ISLA GROSA',
    'jetski.tour.5.desc':
      'La aventura máxima. Llega hasta la isla de Tabarca o Isla Grosa. Almuerzo en puerto incluido.',
    'jetski.tour.5.includes': '⭐ Almuerzo en Proamar Puerto',
    'jetski.card.min': 'MIN.',
    'jetski.card.from': 'DESDE',
    'jetski.card.price': 'PRECIO',
    'jetski.card.premium': 'PREMIUM',
    'jetski.cta.title': '¡RESERVA TU EXCURSIÓN!',
    'jetski.cta.subtitle': 'Confirmación en minutos por WhatsApp',
    'jetski.cta.desc':
      'Escríbenos por WhatsApp y confirmamos disponibilidad en minutos',
    'jetski.cta.btn': 'RESERVAR POR WHATSAPP',

    'reviews.title': 'Lo que dicen nuestros clientes',
    'reviews.subtitle': 'Experiencias reales en el Mediterráneo',
    'reviews.1.text':
      'Una experiencia increíble. Kevin nos atendió por WhatsApp en minutos, todo súper claro y el barco impecable. Volveremos seguro el próximo verano.',
    'reviews.1.author': 'Carlos & Andrea',
    'reviews.1.location': 'Madrid',
    'reviews.2.text':
      'Alquilamos el Prestige 34 para el cumpleaños de mi mujer y fue espectacular. Atardecer en Torrevieja, música, paddle... un día perfecto.',
    'reviews.2.author': 'Javier M.',
    'reviews.2.location': 'Valencia',
    'reviews.3.text':
      'Sin licencia y sin complicaciones. El Marinello es perfecto para una familia con niños. Trato cercano y precio justo. Recomendadísimo.',
    'reviews.3.author': 'Familia Rodríguez',
    'reviews.3.location': 'Alicante',
    'reviews.4.text':
      'Llegamos a Tabarca con el Commander. Las aguas turquesa son de otro mundo. Kevin nos dio todos los tips para sacarle el máximo al día.',
    'reviews.4.author': 'Sophie L.',
    'reviews.4.location': 'Lyon, Francia',
    'reviews.5.text':
      'La moto acuática fue pura adrenalina. Briefing rápido, equipo nuevo y máxima libertad. Una pasada.',
    'reviews.5.author': 'Tomek W.',
    'reviews.5.location': 'Varsovia, Polonia',
  },
  en: {
    'nav.home': 'Home',
    'nav.boats': 'Boats',
    'nav.premium': 'Premium Yachts',
    'nav.jetski': 'Jet Skis',
    'nav.licenses': 'Licenses',
    'nav.howItWorks': 'How it Works',
    'nav.gallery': 'Gallery',
    'nav.reviews': 'Reviews',
    'nav.contact': 'Contact',
    'header.tagline': 'Torrevieja · Boat Rental',
    'header.reserve': 'Book via WhatsApp',
    'hero.headline':
      'Rent your boat in Torrevieja and live the best summer day',
    'hero.subheadline':
      'Boats with and without license, jet skis and premium experiences in the Mediterranean. Easy booking via WhatsApp in minutes.',
    'hero.cta.primary': 'View available boats',
    'hero.cta.secondary': 'Book via WhatsApp',
    'hero.trust.1': 'No cart or online payment',
    'hero.trust.2': 'Immediate response',
    'hero.trust.3': 'With and without license',
    'hero.trust.4': 'Torrevieja · Costa Blanca',
    'trustbar.1': '13 boats available',
    'trustbar.2': 'Departures from Torrevieja',
    'trustbar.3': 'Quick booking via WhatsApp',
    'trustbar.4': 'Experiences for all levels',
    'quiz.title': 'Find your ideal boat',
    'quiz.subtitle': "Answer 4 questions and we'll recommend the best option",
    'quiz.q1': 'How many people are you?',
    'quiz.q1.o1': '1 to 4 people',
    'quiz.q1.o2': '5 to 6 people',
    'quiz.q1.o3': '7 to 8 people',
    'quiz.q1.o4': '9 to 12 people',
    'quiz.q2': 'Do you have a boat license?',
    'quiz.q2.o1': 'Yes, I have a license',
    'quiz.q2.o2': "No, I don't have a license",
    'quiz.q2.o3': 'I want to get a license',
    'quiz.q3': 'What experience are you looking for?',
    'quiz.q3.o1': 'Just a boat',
    'quiz.q3.o2': 'Boat + Jet Ski',
    'quiz.q3.o3': 'Just Jet Ski',
    'quiz.q3.o4': 'Surprise me',
    'quiz.q4': 'What is your budget?',
    'quiz.q4.o1': 'Up to 150€',
    'quiz.q4.o2': 'Between 150€ and 300€',
    'quiz.q4.o3': 'Between 300€ and 500€',
    'quiz.q4.o4': 'More than 500€',
    'quiz.result.title': 'Your ideal option',
    'quiz.result.cta': 'Book this option via WhatsApp',
    'quiz.result.from': 'From',
    'quiz.reset': 'Start over',
    'fleet.title': 'Our fleet in Torrevieja',
    'fleet.filter.all': 'All',
    'fleet.filter.noLicense': 'No License',
    'fleet.filter.license': 'With License',
    'fleet.filter.premium': 'Premium with Skipper',
    'boat.capacity': 'Capacity',
    'boat.license': 'License',
    'boat.location': 'Location',
    'boat.engine': 'Engine',
    'boat.length': 'Length',
    'boat.price.from': 'From',
    'boat.price.lowSeason': 'Low Season (Nov-Mar)',
    'boat.price.highSeason': 'High Season (Apr-Oct)',
    'boat.price.allYear': 'All year',
    'boat.price.hour': 'hour',
    'boat.price.hours': 'hours',
    'boat.price.halfDay': 'Half day',
    'boat.price.fullDay': 'Full day',
    'boat.price.sunset': 'Sunset 2 hours',
    'boat.note.fuel': '⚠️ Fuel not included',
    'boat.note.highSeason': '⚠️ High season rates',
    'boat.note.skipperFuel': '⚠️ Skipper and fuel not included',
    'boat.cta': 'Book via WhatsApp',
    'boat.banner.licenseReq': 'LICENSE REQUIRED',
    'boat.banner.noLicense': 'NO LICENSE REQUIRED',
    'boat.banner.licenseSkipper': 'LICENSE REQUIRED · SKIPPER +20€/H',
    'boat.banner.licensePNBSkipper': 'PNB LICENSE REQUIRED · SKIPPER +20€/H',
    'boat.banner.skipperIncluded': 'SKIPPER INCLUDED',
    'boat.spec.peopleMax': 'PEOPLE MAX',
    'boat.spec.length': 'METERS LENGTH',
    'boat.duration.2h': '2 HOURS',
    'boat.duration.4h': '4 HOURS',
    'boat.duration.8h': '8 HOURS',
    'boat.duration.halfDay': 'HALF DAY',
    'boat.duration.fullDay': 'FULL DAY',
    'boat.durationInfo': 'Half day = 4h · Full day = 8h',
    'boat.specLines.searay.peopleSkipper': '11 PEOPLE + SKIPPER',
    'boat.specLines.searay.paddleIncluded': 'PADDLE BOARD INCLUDED',
    'boat.specLines.prestige.people': '12 PEOPLE + SKIPPER',
    'boat.specLines.prestige.features': '2 CABINS · LOUNGE · KITCHEN',
    'eq.solarium': 'Sunbed',
    'eq.solariumProa': 'Bow sunbed',
    'eq.solariumPopa': 'Stern sunbed',
    'eq.toldo': 'Bimini top',
    'eq.toldoGran': 'Large awning',
    'eq.radio': 'Bluetooth Radio',
    'eq.nevera': 'Cooler with ice',
    'eq.escalera': 'Swim ladder',
    'eq.asientos': 'Padded seats',
    'eq.asientosPopa': 'Adjustable stern seats',
    'eq.mesa': 'Table',
    'eq.ducha': 'Shower',
    'eq.sonda': 'Depth sounder',
    'eq.gps': 'GPS Plotter',
    'eq.camarote': 'Cabin',
    'eq.baño': 'Full bathroom',
    'eq.cocina': 'Equipped kitchen',
    'eq.paddle': 'Paddle surf included',
    'eq.musica': 'Sound system',
    'eq.plataforma': 'Swim platform',
    'eq.radar': 'Radar',
    'eq.piloto': 'Autopilot',
    'eq.helice': 'Bow thruster',
    'eq.molinete': 'Electric windlass',
    'eq.salon': 'Convertible saloon',
    'eq.banera': 'Teak cockpit',
    'desc.marinello':
      'Sail the coast of Torrevieja without a license. Perfect for families and groups who want total freedom.',
    'desc.v2':
      'Explore the Mediterranean with comfort and freedom. Available in Torrevieja and Cabo Roig.',
    'desc.compass':
      'Ideal for those who want an easy, comfortable and hassle-free experience.',
    'desc.calima':
      'Perfect for couples or small groups who want to enjoy the sea at their own pace.',
    'desc.marinelloMartin':
      'A comfortable and functional classic to enjoy Torrevieja without a license.',
    'desc.marinelloNoa': 'Total freedom to sail and enjoy Torrevieja easily.',
    'desc.invictus':
      'Power, comfort and space for groups who want something more.',
    'desc.commander':
      'Ideal for exploring the Alicante coast with freedom and style. Reach Tabarca Island.',
    'desc.quicksilver':
      'Spacious, powerful and perfect for a great day on the water.',
    'desc.flyer':
      'A more complete option for long excursions and premium experiences.',
    'desc.prestige':
      'Perfect for large groups, celebrations and unforgettable Mediterranean sunsets.',
    'desc.searay':
      'A premium experience for groups who want comfort, music and the best sea.',
    'desc.noamar':
      'The most premium experience in the port of Torrevieja. 14 meters of Mediterranean luxury.',
    'desc.nireus':
      'Powerful sports boat with a 200 HP engine. Ideal for groups of up to 12 people looking for speed and fun without needing a license.',
    'desc.ranieri':
      'With 7.8 meters and a 225 HP engine, the Ranieri offers exceptional navigation and a huge bow solarium to enjoy the Torrevieja sun.',
    'desc.smiler':
      'Agile and fun, the Smiler is perfect for groups of up to 8 people. Its 115 HP guarantees an exciting experience at sea.',
    'boat.badge.licencia': 'license',
    'boat.badge.max': 'max',
    'boat.badge.metros': 'meters',
    'boat.badge.motor': 'engine',
    'jetski.title': 'Jet Skis in Torrevieja',
    'jetski.subtitle': 'Pure adrenaline in the Mediterranean',
    'jetski.desc':
      'If you are looking for speed, excitement and fun at sea, jet skis are your option. Available in Torrevieja with safety briefing included. No license required. Free or guided excursions subject to availability.',
    'jetski.f1': 'No license needed',
    'jetski.f2': 'Safety briefing included',
    'jetski.f3': 'Modern jet skis',
    'jetski.f4': 'Free or guided options',
    'jetski.f5': 'Up to 10 miles of coast',
    'jetski.f6': 'Perfect for summer',
    'jetski.note': 'Check availability and price via WhatsApp',
    'jetski.cta': 'Book Jet Ski',
    'license.title': "Don't have a license? We help you get it",
    'license.desc':
      "Kevin Boats also guides you if you want to obtain your nautical license to sail with total freedom. Access more powerful boats and open up new experiences at sea. Tell us your situation and we'll help you choose the license you need.",
    'license.f1': 'Personalized guidance',
    'license.f2': 'Simple and fast process',
    'license.f3': 'Access more boats',
    'license.f4': 'Expand your options at sea',
    'license.cta': 'I want information about licenses',
    'hiw.title': 'Booking is very easy',
    'hiw.s1.title': 'Choose your boat',
    'hiw.s1.desc':
      'Explore the catalog and find the perfect option for your group and budget.',
    'hiw.s2.title': 'Write us on WhatsApp',
    'hiw.s2.desc':
      'Tell us the date, how many people you are and if you have a license.',
    'hiw.s3.title': 'Confirm and book',
    'hiw.s3.desc':
      "Kevin confirms availability and you agree on all details. Let's sail!",
    'hiw.cta': 'Start now',
    'why.title': 'Why choose Kevin Boats?',
    'why.c1.title': 'Close treatment',
    'why.c1.desc':
      'You speak directly with Kevin. No intermediaries, no forms.',
    'why.c2.title': 'We know Torrevieja',
    'why.c2.desc': 'True locals. We know where the best spots are.',
    'why.c3.title': 'With and without license',
    'why.c3.desc':
      'Options for everyone. Do you have a license or not? We have your boat.',
    'why.c4.title': 'Immediate response',
    'why.c4.desc': 'Via WhatsApp we confirm availability in minutes.',
    'why.c5.title': 'Varied fleet',
    'why.c5.desc': '13 boats for couples, families, groups and celebrations.',
    'why.c6.title': 'We help with licenses',
    'why.c6.desc': 'If you want to get your nautical license, we guide you.',
    'gallery.title': 'Experience the Mediterranean like never before',
    'gallery.subtitle': 'Torrevieja · Costa Blanca · Tabarca · Cabo Roig',
    'final.title': 'Ready to live the best summer day?',
    'final.desc':
      'Tell us how many people you are, what date you have in mind and if you have a license. Kevin will find the perfect boat for you in minutes.',
    'final.cta.primary': 'Talk to Kevin on WhatsApp',
    'final.cta.secondary': 'View full catalog',
    'contact.title': 'Contact',
    'contact.location': 'Torrevieja, Spain',
    'contact.whatsapp': 'Bookings via WhatsApp',
    'contact.instagram': 'Instagram: @kevin.boats',
    'contact.response': 'Fast response guaranteed',
    'contact.cta': 'Write on WhatsApp',
    'footer.desc': 'Boat and jet ski rental',
    'footer.links': 'Quick links',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved',
    'footer.legal': 'Legal',
    'footer.cookies': 'Cookie Policy',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms & Conditions',
    'footer.dataProtection': 'Data Protection',
    'footer.credit': 'Design & development by',
    'legal.title': 'Legal Information',
    'legal.close': 'Close',
    'legal.cookies.title': 'Cookie Policy',
    'legal.cookies.body':
      'This website uses first-party and third-party cookies to improve your browsing experience, analyze site usage, and personalize content. Cookies are small text files stored on your device when you visit the site. You can configure or reject the use of cookies at any time through your browser settings. By continuing to browse this site, you accept the use of cookies as described in this policy.',
    'legal.privacy.title': 'Privacy Policy',
    'legal.privacy.body':
      'At Kevin Boats we respect your privacy and are committed to protecting the personal data you share with us. Data collected through WhatsApp or any other communication channel is used solely to manage your booking and respond to your inquiries. We do not share your data with third parties without your express consent. You have the right to access, rectify and delete your personal data at any time by contacting us directly.',
    'legal.terms.title': 'Terms & Conditions',
    'legal.terms.body':
      'Boat rental is subject to availability and weather conditions. The customer must present valid documentation and, where applicable, the corresponding nautical license. Kevin Boats reserves the right to cancel the booking for safety reasons. Improper use of vessels may entail legal liability. All bookings are managed directly via WhatsApp and confirmed by mutual agreement.',
    'legal.dataProtection.title': 'Data Protection (GDPR)',
    'legal.dataProtection.body':
      'In accordance with the General Data Protection Regulation (GDPR) EU 2016/679, we inform you that the personal data provided will be treated confidentially. Data controller: Kevin Boats, Torrevieja, Spain. Purpose: booking management and commercial communication. Legal basis: consent of the data subject. Rights: access, rectification, deletion, opposition, limitation and portability of data by contacting us via WhatsApp.',
    'cookieBanner.text':
      'We use cookies to improve your browsing experience. By continuing, you accept our cookie policy.',
    'cookieBanner.accept': 'Accept',
    'cookieBanner.reject': 'Reject',
    'wa.general':
      "Hi Kevin 👋\nI'm interested in booking [BARCO]\nDate: [FECHA]\nPeople: [NÚMERO]\nI have a license: [SÍ/NO]\nBudget: [PRESUPUESTO]\nIs it available?",
    'wa.jetski':
      "Hi Kevin 👋\nI'm interested in jet skis in Torrevieja.\nDate: [FECHA]\nPeople: [NÚMERO]\nWhat is the price and availability?",
    'wa.license':
      "Hi Kevin 👋\nI'm interested in information about nautical licenses.\nCan you guide me?",
    'wa.help':
      "Hi Kevin, I'm interested in booking a boat in Torrevieja. Can you help me?",
    'wa.premium':
      'Hi Kevin 👋\nI am interested in booking [BARCO].\nDate: [FECHA]\nPeople: [NÚMERO]\nDuration: [4H or 8H]\nIs it available and what is the final price?',
    'wa.searay':
      'Hi Kevin 👋 I am interested in booking the Sea Ray 290 Sundeck with skipper. Is it available?',

    // Premium Fleet
    'premium.badge': 'PROFESSIONAL SKIPPER INCLUDED',
    'premium.title': 'PREMIUM YACHTS',
    'premium.subtitle': 'You just enjoy — the captain takes care of everything',
    'premium.description':
      'For large groups, special celebrations and luxury experiences in the Mediterranean. No license required.',
    'premium.captain': 'WITH',
    'premium.captainLabel': 'skipper',
    'premium.max': 'max',
    'premium.meters': 'meters',
    'premium.reserve': 'BOOK NOW',
    'premium.price': 'PRICE',
    'premium.boat.monaco.desc':
      'Large format premium boat with skipper included. Perfect for groups looking for comfort and exclusivity.',
    'premium.boat.diamonte.desc':
      'Premium boat with skipper included. Perfect for groups looking for comfort and exclusivity in the Mediterranean.',
    'premium.boat.lagoon.desc':
      'Next-generation luxury catamaran. Combines style and functionality for a premium experience in the Mediterranean.',
    'premium.boat.lagoon.note': '+ fuel not included',
    'premium.boat.prestige.desc':
      'Premium yacht with 2 cabins, lounge and kitchen. Professional skipper included for up to 12 people.',
    'premium.boat.prestige.note': '2 cabins · Lounge · Kitchen',
    'premium.boat.puravida.desc':
      'The most exclusive catamaran in the Kevin Boats fleet. 15 meters of pure Mediterranean luxury with professional captain included. The ultimate experience in Torrevieja.',
    'premium.boat.puravida.badge': 'PREMIUM EXPERIENCE',
    'premium.boat.nireus.desc':
      'Powerful and spacious 6-meter boat, ideal for groups of up to 12 people looking for speed and comfort with a professional skipper.',
    'premium.aria.prev': 'Previous photo',
    'premium.aria.next': 'Next photo',
    'premium.aria.zoom': 'Zoom photo',
    'premium.aria.close': 'Close',

    // Jet Ski Tours
    'jetski.tour.badge': 'NO LICENSE REQUIRED',
    'jetski.tour.title': 'JET SKIS\nIN TORREVIEJA',
    'jetski.tour.subtitle': 'Pure adrenaline in the Mediterranean',
    'jetski.tour.f1': 'No license needed',
    'jetski.tour.f2': '5 routes available',
    'jetski.tour.f3': 'Safety briefing included',
    'jetski.tour.f4': 'Departure from Torrevieja',
    'jetski.tour.1.name': 'THE BEACHES',
    'jetski.tour.1.desc':
      'Tour the most beautiful beaches of Torrevieja. Perfect to start.',
    'jetski.tour.2.name': 'THE COVES',
    'jetski.tour.2.desc':
      'Discover the secret coves of the Costa Blanca. Crystal clear waters guaranteed.',
    'jetski.tour.3.name': 'CABO ROIG',
    'jetski.tour.3.desc':
      'Sail to Cabo Roig and enjoy the most spectacular views of the coast.',
    'jetski.tour.4.name': 'AGUAMARINA',
    'jetski.tour.4.desc':
      'Extended route to Aguamarina. Free navigation through the best coves of the Costa Blanca.',
    'jetski.tour.5.name': 'TABARCA / ISLA GROSA',
    'jetski.tour.5.desc':
      'The ultimate adventure. Reach the island of Tabarca or Isla Grosa. Lunch at port included.',
    'jetski.tour.5.includes': '⭐ Lunch at Proamar Puerto',
    'jetski.card.min': 'MIN.',
    'jetski.card.from': 'FROM',
    'jetski.card.price': 'PRICE',
    'jetski.card.premium': 'PREMIUM',
    'jetski.cta.title': 'BOOK YOUR TOUR!',
    'jetski.cta.subtitle': 'Confirmation in minutes via WhatsApp',
    'jetski.cta.desc':
      'Write us on WhatsApp and we confirm availability in minutes',
    'jetski.cta.btn': 'BOOK BY WHATSAPP',

    'reviews.title': 'What our customers say',
    'reviews.subtitle': 'Real experiences in the Mediterranean',
    'reviews.1.text':
      "An incredible experience. Kevin replied on WhatsApp in minutes, everything was super clear and the boat was spotless. We'll definitely be back next summer.",
    'reviews.1.author': 'Carlos & Andrea',
    'reviews.1.location': 'Madrid',
    'reviews.2.text':
      "We rented the Prestige 34 for my wife's birthday and it was spectacular. Sunset over Torrevieja, music, paddle… a perfect day.",
    'reviews.2.author': 'Javier M.',
    'reviews.2.location': 'Valencia',
    'reviews.3.text':
      'No license, no hassle. The Marinello is perfect for a family with kids. Personal touch and fair price. Highly recommended.',
    'reviews.3.author': 'The Rodríguez Family',
    'reviews.3.location': 'Alicante',
    'reviews.4.text':
      'We made it to Tabarca with the Commander. The turquoise water is out of this world. Kevin gave us all the tips to make the most of the day.',
    'reviews.4.author': 'Sophie L.',
    'reviews.4.location': 'Lyon, France',
    'reviews.5.text':
      'The jet ski was pure adrenaline. Quick briefing, brand-new equipment and total freedom. Amazing.',
    'reviews.5.author': 'Tomek W.',
    'reviews.5.location': 'Warsaw, Poland',
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.premium': 'Yachts Premium',
    'nav.gallery': 'Galerie',
    'nav.reviews': 'Avis',
    'nav.boats': 'Bateaux',
    'nav.jetski': 'Jet Skis',
    'nav.licenses': 'Permis',
    'nav.howItWorks': 'Comment ça marche',
    'nav.contact': 'Contact',
    'header.tagline': 'Torrevieja · Location de Bateaux',
    'header.reserve': 'Réserver via WhatsApp',
    'hero.headline':
      "Louez votre bateau à Torrevieja et vivez la meilleure journée d'été",
    'hero.subheadline':
      'Bateaux avec et sans permis, jet skis et expériences premium en Méditerranée. Réservation facile via WhatsApp en quelques minutes.',
    'hero.cta.primary': 'Voir les bateaux disponibles',
    'hero.cta.secondary': 'Réserver via WhatsApp',
    'hero.trust.1': 'Pas de panier ni de paiement en ligne',
    'hero.trust.2': 'Réponse immédiate',
    'hero.trust.3': 'Avec et sans permis',
    'hero.trust.4': 'Torrevieja · Costa Blanca',
    'trustbar.1': '13 bateaux disponibles',
    'trustbar.2': 'Départs de Torrevieja',
    'trustbar.3': 'Réservation rapide via WhatsApp',
    'trustbar.4': 'Expériences pour tous les niveaux',
    'quiz.title': 'Trouvez votre bateau idéal',
    'quiz.subtitle':
      'Répondez à 4 questions et nous vous recommanderons la meilleure option',
    'quiz.q1': 'Combien de personnes êtes-vous ?',
    'quiz.q1.o1': '1 à 4 personnes',
    'quiz.q1.o2': '5 à 6 personnes',
    'quiz.q1.o3': '7 à 8 personnes',
    'quiz.q1.o4': '9 à 12 personnes',
    'quiz.q2': 'Avez-vous un permis bateau ?',
    'quiz.q2.o1': "Oui, j'ai un permis",
    'quiz.q2.o2': "Non, je n'ai pas de permis",
    'quiz.q2.o3': 'Je veux passer le permis',
    'quiz.q3': 'Quelle expérience recherchez-vous ?',
    'quiz.q3.o1': 'Juste un bateau',
    'quiz.q3.o2': 'Bateau + Jet Ski',
    'quiz.q3.o3': 'Juste Jet Ski',
    'quiz.q3.o4': 'Surprenez-moi',
    'quiz.q4': 'Quel est votre budget ?',
    'quiz.q4.o1': "Jusqu'à 150€",
    'quiz.q4.o2': 'Entre 150€ et 300€',
    'quiz.q4.o3': 'Entre 300€ et 500€',
    'quiz.q4.o4': 'Plus de 500€',
    'quiz.result.title': 'Votre option idéale',
    'quiz.result.cta': 'Réserver cette option via WhatsApp',
    'quiz.result.from': 'À partir de',
    'quiz.reset': 'Recommencer',
    'fleet.title': 'Notre flotte à Torrevieja',
    'fleet.filter.all': 'Tous',
    'fleet.filter.noLicense': 'Sans Permis',
    'fleet.filter.license': 'Avec Permis',
    'fleet.filter.premium': 'Premium avec Skipper',
    'boat.capacity': 'Capacité',
    'boat.license': 'Permis',
    'boat.location': 'Emplacement',
    'boat.engine': 'Moteur',
    'boat.length': 'Longueur',
    'boat.price.from': 'À partir de',
    'boat.price.lowSeason': 'Basse Saison (Nov-Mar)',
    'boat.price.highSeason': 'Haute Saison (Avr-Oct)',
    'boat.price.allYear': "Toute l'année",
    'boat.price.hour': 'heure',
    'boat.price.hours': 'heures',
    'boat.price.halfDay': 'Demi-journée',
    'boat.price.fullDay': 'Journée complète',
    'boat.price.sunset': 'Coucher de soleil 2 heures',
    'boat.note.fuel': '⚠️ Carburant non inclus',
    'boat.note.highSeason': '⚠️ Tarifs haute saison',
    'boat.note.skipperFuel': '⚠️ Skipper et carburant non inclus',
    'boat.cta': 'Réserver via WhatsApp',
    'boat.banner.licenseReq': 'PERMIS DE NAVIGATION REQUIS',
    'boat.banner.noLicense': 'SANS PERMIS DE NAVIGATION',
    'boat.banner.licenseSkipper': 'PERMIS REQUIS · PATRON +20€/H',
    'boat.banner.licensePNBSkipper': 'PERMIS PNB REQUIS · PATRON +20€/H',
    'boat.banner.skipperIncluded': 'SKIPPER INCLUS',
    'boat.spec.peopleMax': 'PERSONNES MAX',
    'boat.spec.length': 'MÈTRES DE LONGUEUR',
    'boat.duration.2h': '2 HEURES',
    'boat.duration.4h': '4 HEURES',
    'boat.duration.8h': '8 HEURES',
    'boat.duration.halfDay': 'DEMI-JOURNÉE',
    'boat.duration.fullDay': 'JOURNÉE COMPLÈTE',
    'boat.durationInfo': 'Demi-journée = 4h · Journée = 8h',
    'boat.specLines.searay.peopleSkipper': '11 PERSONNES + SKIPPER',
    'boat.specLines.searay.paddleIncluded': 'PADDLE INCLUS',
    'boat.specLines.prestige.people': '12 PERSONNES + SKIPPER',
    'boat.specLines.prestige.features': '2 CABINES · SALON · CUISINE',
    'eq.solarium': 'Bain de soleil',
    'eq.solariumProa': 'Bain de soleil avant',
    'eq.solariumPopa': 'Bain de soleil arrière',
    'eq.toldo': 'Taud de soleil',
    'eq.toldoGran': 'Grand auvent',
    'eq.radio': 'Radio Bluetooth',
    'eq.nevera': 'Glacière avec glace',
    'eq.escalera': 'Échelle de bain',
    'eq.asientos': 'Sièges rembourrés',
    'eq.asientosPopa': 'Sièges arrière réglables',
    'eq.mesa': 'Table',
    'eq.ducha': 'Douche',
    'eq.sonda': 'Sondeur',
    'eq.gps': 'Traceur GPS',
    'eq.camarote': 'Cabine',
    'eq.baño': 'Salle de bain complète',
    'eq.cocina': 'Cuisine équipée',
    'eq.paddle': 'Paddle surf inclus',
    'eq.musica': 'Système audio',
    'eq.plataforma': 'Plateforme de bain',
    'eq.radar': 'Radar',
    'eq.piloto': 'Pilote automatique',
    'eq.helice': "Propulseur d'étrave",
    'eq.molinete': 'Guindeau électrique',
    'eq.salon': 'Salon convertible',
    'eq.banera': 'Cockpit en teck',
    'desc.marinello':
      'Naviguez sur la côte de Torrevieja sans permis. Parfait pour les familles et les groupes qui veulent une liberté totale.',
    'desc.v2':
      'Explorez la Méditerranée avec confort et liberté. Disponible à Torrevieja et Cabo Roig.',
    'desc.compass':
      'Idéal pour ceux qui veulent une expérience facile, confortable et sans tracas.',
    'desc.calima':
      'Parfait pour les couples ou les petits groupes qui veulent profiter de la mer à leur propre rythme.',
    'desc.marinelloMartin':
      'Un classique confortable et fonctionnel pour profiter de Torrevieja sans permis.',
    'desc.marinelloNoa':
      'Liberté totale pour naviguer et profiter de Torrevieja facilement.',
    'desc.invictus':
      'Puissance, confort et espace pour les groupes qui veulent quelque chose de plus.',
    'desc.commander':
      "Idéal pour explorer la côte d'Alicante avec liberté et style. Rejoignez l'île de Tabarca.",
    'desc.quicksilver':
      "Spacieux, puissant et parfait pour passer une excellente journée sur l'eau.",
    'desc.flyer':
      'Une option plus complète pour de longues excursions et des expériences premium.',
    'desc.prestige':
      'Parfait pour les grands groupes, les célébrations et les couchers de soleil méditerranéens inoubliables.',
    'desc.searay':
      'Une expérience premium pour les groupes qui veulent du confort, de la musique et la meilleure mer.',
    'desc.noamar':
      "L'expérience la plus premium du port de Torrevieja. 14 mètres de luxe méditerranéen.",
    'desc.nireus':
      "Bateau sportif puissant avec un moteur de 200 CV. Idéal pour les groupes jusqu'à 12 personnes recherchant vitesse et plaisir sans avoir besoin de permis.",
    'desc.ranieri':
      'Avec 7,8 mètres et un moteur de 225 CV, le Ranieri offre une navigation exceptionnelle et un immense solarium avant pour profiter du soleil de Torrevieja.',
    'desc.smiler':
      "Agile et amusant, le Smiler est parfait pour les groupes jusqu'à 8 personnes. Ses 115 CV garantissent une expérience passionnante en mer.",
    'boat.badge.licencia': 'permis',
    'boat.badge.max': 'max',
    'boat.badge.metros': 'mètres',
    'boat.badge.motor': 'moteur',
    'jetski.title': 'Jet Skis à Torrevieja',
    'jetski.subtitle': 'Adrénaline pure en Méditerranée',
    'jetski.desc':
      "Si vous recherchez la vitesse, l'excitation et le plaisir en mer, les jet skis sont votre option. Disponibles à Torrevieja avec briefing de sécurité inclus. Aucun permis requis. Excursions libres ou guidées selon disponibilité.",
    'jetski.f1': 'Aucun permis nécessaire',
    'jetski.f2': 'Briefing de sécurité inclus',
    'jetski.f3': 'Jet skis modernes',
    'jetski.f4': 'Options libres ou guidées',
    'jetski.f5': "Jusqu'à 10 milles de côte",
    'jetski.f6': "Parfait pour l'été",
    'jetski.note': 'Vérifiez la disponibilité et le prix via WhatsApp',
    'jetski.cta': 'Réserver un Jet Ski',
    'license.title': "Vous n'avez pas de permis ? Nous vous aidons à l'obtenir",
    'license.desc':
      'Kevin Boats vous guide également si vous souhaitez obtenir votre permis nautique pour naviguer en toute liberté. Accédez à des bateaux plus puissants et ouvrez de nouvelles expériences en mer. Racontez-nous votre situation et nous vous aiderons à choisir le permis dont vous avez besoin.',
    'license.f1': 'Accompagnement personnalisé',
    'license.f2': 'Processus simple et rapide',
    'license.f3': 'Accédez à plus de bateaux',
    'license.f4': 'Élargissez vos options en mer',
    'license.cta': 'Je veux des informations sur les permis',
    'hiw.title': 'Réserver est très facile',
    'hiw.s1.title': 'Choisissez votre bateau',
    'hiw.s1.desc':
      "Explorez le catalogue et trouvez l'option parfaite pour votre groupe et votre budget.",
    'hiw.s2.title': 'Écrivez-nous sur WhatsApp',
    'hiw.s2.desc':
      'Indiquez-nous la date, combien de personnes vous êtes et si vous avez un permis.',
    'hiw.s3.title': 'Confirmez et réservez',
    'hiw.s3.desc':
      'Kevin confirme la disponibilité et vous convenez de tous les détails. Naviguons !',
    'hiw.cta': 'Commencer maintenant',
    'why.title': 'Pourquoi choisir Kevin Boats ?',
    'why.c1.title': 'Traitement de proximité',
    'why.c1.desc':
      "Vous parlez directement avec Kevin. Pas d'intermédiaires, pas de formulaires.",
    'why.c2.title': 'Nous connaissons Torrevieja',
    'why.c2.desc':
      'De vrais locaux. Nous savons où sont les meilleurs endroits.',
    'why.c3.title': 'Avec et sans permis',
    'why.c3.desc':
      'Des options pour tous. Avez-vous un permis ou non ? Nous avons votre bateau.',
    'why.c4.title': 'Réponse immédiate',
    'why.c4.desc':
      'Via WhatsApp, nous confirmons la disponibilité en quelques minutes.',
    'why.c5.title': 'Flotte variée',
    'why.c5.desc':
      '13 bateaux pour couples, familles, groupes et célébrations.',
    'why.c6.title': 'Nous aidons avec les permis',
    'why.c6.desc':
      'Si vous souhaitez obtenir votre permis nautique, nous vous guidons.',
    'gallery.title': 'Vivez la Méditerranée comme jamais auparavant',
    'gallery.subtitle': 'Torrevieja · Costa Blanca · Tabarca · Cabo Roig',
    'final.title': "Prêt à vivre la meilleure journée d'été ?",
    'final.desc':
      'Dites-nous combien de personnes vous êtes, quelle date vous avez en tête et si vous avez un permis. Kevin vous trouvera le bateau parfait en quelques minutes.',
    'final.cta.primary': 'Parler à Kevin sur WhatsApp',
    'final.cta.secondary': 'Voir le catalogue complet',
    'contact.title': 'Contact',
    'contact.location': 'Torrevieja, Espagne',
    'contact.whatsapp': 'Réservations via WhatsApp',
    'contact.instagram': 'Instagram: @kevin.boats',
    'contact.response': 'Réponse rapide garantie',
    'contact.cta': 'Écrire sur WhatsApp',
    'footer.desc': 'Location de bateaux et jet skis',
    'footer.links': 'Liens rapides',
    'footer.contact': 'Contact',
    'footer.rights': 'Tous droits réservés',
    'footer.legal': 'Légal',
    'footer.cookies': 'Politique de Cookies',
    'footer.privacy': 'Politique de Confidentialité',
    'footer.terms': 'Conditions Générales',
    'footer.dataProtection': 'Protection des Données',
    'footer.credit': 'Conception et développement par',
    'legal.title': 'Informations Légales',
    'legal.close': 'Fermer',
    'legal.cookies.title': 'Politique de Cookies',
    'legal.cookies.body':
      "Ce site utilise des cookies propres et tiers pour améliorer votre expérience de navigation, analyser l'utilisation du site et personnaliser le contenu. Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous visitez le site. Vous pouvez configurer ou refuser l'utilisation des cookies à tout moment via les paramètres de votre navigateur. En continuant à naviguer, vous acceptez l'utilisation des cookies décrite dans cette politique.",
    'legal.privacy.title': 'Politique de Confidentialité',
    'legal.privacy.body':
      "Chez Kevin Boats, nous respectons votre vie privée et nous engageons à protéger les données personnelles que vous partagez avec nous. Les données collectées via WhatsApp ou tout autre canal de communication sont utilisées uniquement pour gérer votre réservation et répondre à vos demandes. Nous ne partageons pas vos données avec des tiers sans votre consentement exprès. Vous avez le droit d'accéder, de rectifier et de supprimer vos données personnelles à tout moment en nous contactant directement.",
    'legal.terms.title': 'Conditions Générales',
    'legal.terms.body':
      "La location de bateaux est soumise à la disponibilité et aux conditions météorologiques. Le client doit présenter des documents valides et, le cas échéant, le permis nautique correspondant. Kevin Boats se réserve le droit d'annuler la réservation pour des raisons de sécurité. Une utilisation inappropriée des bateaux peut entraîner une responsabilité légale. Toutes les réservations sont gérées directement via WhatsApp et confirmées d'un commun accord.",
    'legal.dataProtection.title': 'Protection des Données (RGPD)',
    'legal.dataProtection.body':
      'Conformément au Règlement Général sur la Protection des Données (RGPD) UE 2016/679, nous vous informons que les données personnelles fournies seront traitées de manière confidentielle. Responsable du traitement: Kevin Boats, Torrevieja, Espagne. Finalité: gestion des réservations et communication commerciale. Base légale: consentement de la personne concernée. Droits: accès, rectification, suppression, opposition, limitation et portabilité des données en nous contactant via WhatsApp.',
    'cookieBanner.text':
      'Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre politique de cookies.',
    'cookieBanner.accept': 'Accepter',
    'cookieBanner.reject': 'Refuser',
    'wa.general':
      "Salut Kevin 👋\nJe suis intéressé par la réservation de [BARCO]\nDate: [FECHA]\nPersonnes: [NÚMERO]\nJ'ai un permis: [SÍ/NO]\nBudget: [PRESUPUESTO]\nEst-il disponible ?",
    'wa.jetski':
      'Salut Kevin 👋\nJe suis intéressé par les jet skis à Torrevieja.\nDate: [FECHA]\nPersonnes: [NÚMERO]\nQuel est le prix et la disponibilité ?',
    'wa.license':
      'Salut Kevin 👋\nJe suis intéressé par des informations sur les permis nautiques.\nPouvez-vous me guider ?',
    'wa.help':
      "Salut Kevin, je suis intéressé par la réservation d'un bateau à Torrevieja. Pouvez-vous m'aider ?",
    'wa.premium':
      'Salut Kevin 👋\nJe suis intéressé par la réservation de [BARCO].\nDate: [FECHA]\nPersonnes: [NÚMERO]\nDurée: [4H ou 8H]\nEst-il disponible et quel est le prix final ?',
    'wa.searay':
      'Salut Kevin 👋 Je suis intéressé(e) par la réservation du Sea Ray 290 Sundeck avec skipper. Est-il disponible ?',

    // Premium Fleet
    'premium.badge': 'SKIPPER PROFESSIONNEL INCLUS',
    'premium.title': 'YACHTS PREMIUM',
    'premium.subtitle': "Profitez simplement — le capitaine s'occupe de tout",
    'premium.description':
      'Pour les grands groupes, les célébrations spéciales et les expériences de luxe en Méditerranée. Aucun permis requis.',
    'premium.captain': 'AVEC',
    'premium.captainLabel': 'skipper',
    'premium.max': 'max',
    'premium.meters': 'mètres',
    'premium.reserve': 'RÉSERVER',
    'premium.price': 'PRIX',
    'premium.boat.monaco.desc':
      'Bateau premium grand format avec skipper inclus. Parfait pour les groupes recherchant confort et exclusivité.',
    'premium.boat.diamonte.desc':
      'Bateau premium avec skipper inclus. Parfait pour les groupes recherchant confort et exclusivité en Méditerranée.',
    'premium.boat.lagoon.desc':
      'Catamaran de luxe de dernière génération. Combine style et fonctionnalité pour une expérience premium en Méditerranée.',
    'premium.boat.lagoon.note': '+ carburant non inclus',
    'premium.boat.prestige.desc':
      "Yacht premium avec 2 cabines, salon et cuisine. Skipper professionnel inclus pour jusqu'à 12 personnes.",
    'premium.boat.prestige.note': '2 cabines · Salon · Cuisine',
    'premium.boat.puravida.desc':
      "Le catamaran le plus exclusif de la flotte Kevin Boats. 15 mètres de pur luxe méditerranéen avec capitaine professionnel inclus. L'expérience ultime à Torrevieja.",
    'premium.boat.puravida.badge': 'EXPÉRIENCE PREMIUM',
    'premium.boat.nireus.desc':
      "Bateau puissant et spacieux de 6 mètres, idéal pour les groupes jusqu'à 12 personnes recherchant vitesse et confort avec un skipper professionnel.",
    'premium.aria.prev': 'Photo précédente',
    'premium.aria.next': 'Photo suivante',
    'premium.aria.zoom': 'Agrandir la photo',
    'premium.aria.close': 'Fermer',

    // Jet Ski Tours
    'jetski.tour.badge': 'SANS PERMIS NÉCESSAIRE',
    'jetski.tour.title': 'JET SKIS\nÀ TORREVIEJA',
    'jetski.tour.subtitle': 'Adrénaline pure en Méditerranée',
    'jetski.tour.f1': 'Sans permis nécessaire',
    'jetski.tour.f2': '5 itinéraires disponibles',
    'jetski.tour.f3': 'Briefing de sécurité inclus',
    'jetski.tour.f4': 'Départ de Torrevieja',
    'jetski.tour.1.name': 'LES PLAGES',
    'jetski.tour.1.desc':
      'Parcourez les plus belles plages de Torrevieja. Parfait pour commencer.',
    'jetski.tour.2.name': 'LES CRIQUES',
    'jetski.tour.2.desc':
      'Découvrez les criques secrètes de la Costa Blanca. Eaux cristallines garanties.',
    'jetski.tour.3.name': 'CABO ROIG',
    'jetski.tour.3.desc':
      "Naviguez jusqu'à Cabo Roig et profitez des vues les plus spectaculaires de la côte.",
    'jetski.tour.4.name': 'AGUAMARINA',
    'jetski.tour.4.desc':
      "Itinéraire prolongé jusqu'à Aguamarina. Navigation libre à travers les meilleures criques de la Costa Blanca.",
    'jetski.tour.5.name': 'TABARCA / ISLA GROSA',
    'jetski.tour.5.desc':
      "L'aventure ultime. Atteignez l'île de Tabarca ou Isla Grosa. Déjeuner au port inclus.",
    'jetski.tour.5.includes': '⭐ Déjeuner à Proamar Puerto',
    'jetski.card.min': 'MIN.',
    'jetski.card.from': 'DÈS',
    'jetski.card.price': 'PRIX',
    'jetski.card.premium': 'PREMIUM',
    'jetski.cta.title': 'RÉSERVEZ VOTRE EXCURSION !',
    'jetski.cta.subtitle': 'Confirmation en quelques minutes via WhatsApp',
    'jetski.cta.desc':
      'Écrivez-nous sur WhatsApp et nous confirmons la disponibilité en quelques minutes',
    'jetski.cta.btn': 'RÉSERVER PAR WHATSAPP',

    'reviews.title': 'Ce que disent nos clients',
    'reviews.subtitle': 'Vraies expériences en Méditerranée',
    'reviews.1.text':
      "Une expérience incroyable. Kevin a répondu sur WhatsApp en quelques minutes, tout était très clair et le bateau impeccable. Nous reviendrons sans hésiter l'été prochain.",
    'reviews.1.author': 'Carlos & Andrea',
    'reviews.1.location': 'Madrid',
    'reviews.2.text':
      "Nous avons loué le Prestige 34 pour l'anniversaire de ma femme et c'était spectaculaire. Coucher de soleil sur Torrevieja, musique, paddle… une journée parfaite.",
    'reviews.2.author': 'Javier M.',
    'reviews.2.location': 'Valence',
    'reviews.3.text':
      'Sans permis et sans tracas. Le Marinello est parfait pour une famille avec enfants. Contact chaleureux et prix juste. Hautement recommandé.',
    'reviews.3.author': 'Famille Rodríguez',
    'reviews.3.location': 'Alicante',
    'reviews.4.text':
      'Nous avons rejoint Tabarca avec le Commander. Les eaux turquoise sont uniques. Kevin nous a donné tous les conseils pour profiter au maximum.',
    'reviews.4.author': 'Sophie L.',
    'reviews.4.location': 'Lyon, France',
    'reviews.5.text':
      "Le jet ski, c'était de l'adrénaline pure. Briefing rapide, matériel neuf et liberté totale. Génial.",
    'reviews.5.author': 'Tomek W.',
    'reviews.5.location': 'Varsovie, Pologne',
  },
  pl: {
    'nav.home': 'Strona główna',
    'nav.boats': 'Łodzie',
    'nav.premium': 'Jachty Premium',
    'nav.jetski': 'Skutery wodne',
    'nav.licenses': 'Licencje',
    'nav.howItWorks': 'Jak to działa',
    'nav.gallery': 'Galeria',
    'nav.reviews': 'Opinie',
    'nav.contact': 'Kontakt',
    'header.tagline': 'Torrevieja · Wynajem Łodzi',
    'header.reserve': 'Rezerwuj przez WhatsApp',
    'hero.headline':
      'Wynajmij łódź w Torrevieja i przeżyj najlepszy letni dzień',
    'hero.subheadline':
      'Łodzie z licencją i bez, skutery wodne i doświadczenia premium na Morzu Śródziemnym. Łatwa rezerwacja przez WhatsApp w kilka minut.',
    'hero.cta.primary': 'Zobacz dostępne łodzie',
    'hero.cta.secondary': 'Rezerwuj przez WhatsApp',
    'hero.trust.1': 'Bez koszyka i płatności online',
    'hero.trust.2': 'Natychmiastowa odpowiedź',
    'hero.trust.3': 'Z licencją i bez',
    'hero.trust.4': 'Torrevieja · Costa Blanca',
    'trustbar.1': '13 dostępnych łodzi',
    'trustbar.2': 'Wypłynięcia z Torrevieja',
    'trustbar.3': 'Szybka rezerwacja przez WhatsApp',
    'trustbar.4': 'Doświadczenia dla wszystkich poziomów',
    'quiz.title': 'Znajdź idealną łódź',
    'quiz.subtitle': 'Odpowiedz na 4 pytania, a my polecimy najlepszą opcję',
    'quiz.q1': 'Ile was jest?',
    'quiz.q1.o1': '1 do 4 osób',
    'quiz.q1.o2': '5 do 6 osób',
    'quiz.q1.o3': '7 do 8 osób',
    'quiz.q1.o4': '9 do 12 osób',
    'quiz.q2': 'Czy masz licencję na łódź?',
    'quiz.q2.o1': 'Tak, mam licencję',
    'quiz.q2.o2': 'Nie, nie mam licencji',
    'quiz.q2.o3': 'Chcę zdobyć licencję',
    'quiz.q3': 'Jakiego doświadczenia szukasz?',
    'quiz.q3.o1': 'Tylko łódź',
    'quiz.q3.o2': 'Łódź + Skuter wodny',
    'quiz.q3.o3': 'Tylko Skuter wodny',
    'quiz.q3.o4': 'Zaskocz mnie',
    'quiz.q4': 'Jaki jest twój budżet?',
    'quiz.q4.o1': 'Do 150€',
    'quiz.q4.o2': 'Między 150€ a 300€',
    'quiz.q4.o3': 'Między 300€ a 500€',
    'quiz.q4.o4': 'Powyżej 500€',
    'quiz.result.title': 'Twoja idealna opcja',
    'quiz.result.cta': 'Zarezerwuj tę opcję przez WhatsApp',
    'quiz.result.from': 'Od',
    'quiz.reset': 'Zacznij od nowa',
    'fleet.title': 'Nasza flota w Torrevieja',
    'fleet.filter.all': 'Wszystkie',
    'fleet.filter.noLicense': 'Bez Licencji',
    'fleet.filter.license': 'Z Licencją',
    'fleet.filter.premium': 'Premium ze Skipperem',
    'boat.capacity': 'Pojemność',
    'boat.license': 'Licencja',
    'boat.location': 'Lokalizacja',
    'boat.engine': 'Silnik',
    'boat.length': 'Długość',
    'boat.price.from': 'Od',
    'boat.price.lowSeason': 'Niski Sezon (Lis-Mar)',
    'boat.price.highSeason': 'Wysoki Sezon (Kwi-Paź)',
    'boat.price.allYear': 'Cały rok',
    'boat.price.hour': 'godzina',
    'boat.price.hours': 'godziny',
    'boat.price.halfDay': 'Pół dnia',
    'boat.price.fullDay': 'Cały dzień',
    'boat.price.sunset': 'Zachód słońca 2 godziny',
    'boat.note.fuel': '⚠️ Paliwo nie jest wliczone',
    'boat.note.highSeason': '⚠️ Ceny w wysokim sezonie',
    'boat.note.skipperFuel': '⚠️ Skipper i paliwo nie są wliczone',
    'boat.cta': 'Rezerwuj przez WhatsApp',
    'boat.banner.licenseReq': 'WYMAGANA LICENCJA ŻEGLARSKA',
    'boat.banner.noLicense': 'BEZ LICENCJI ŻEGLARSKIEJ',
    'boat.banner.licenseSkipper': 'WYMAGANA LICENCJA · PATRON +20€/H',
    'boat.banner.licensePNBSkipper': 'WYMAGANA LICENCJA PNB · PATRON +20€/H',
    'boat.banner.skipperIncluded': 'SKIPER W CENIE',
    'boat.spec.peopleMax': 'OSÓB MAX',
    'boat.spec.length': 'METRÓW DŁUGOŚCI',
    'boat.duration.2h': '2 GODZINY',
    'boat.duration.4h': '4 GODZINY',
    'boat.duration.8h': '8 GODZIN',
    'boat.duration.halfDay': 'PÓŁ DNIA',
    'boat.duration.fullDay': 'CAŁY DZIEŃ',
    'boat.durationInfo': 'Pół dnia = 4h · Cały dzień = 8h',
    'boat.specLines.searay.peopleSkipper': '11 OSÓB + SKIPER',
    'boat.specLines.searay.paddleIncluded': 'DESKA SUP W CENIE',
    'boat.specLines.prestige.people': '12 OSÓB + SKIPER',
    'boat.specLines.prestige.features': '2 KAJUTY · SALON · KUCHNIA',
    'eq.solarium': 'Leżak',
    'eq.solariumProa': 'Leżak dziobowy',
    'eq.solariumPopa': 'Leżak rufowy',
    'eq.toldo': 'Markiza Bimini',
    'eq.toldoGran': 'Duża markiza',
    'eq.radio': 'Radio Bluetooth',
    'eq.nevera': 'Lodówka z lodem',
    'eq.escalera': 'Drabinka do pływania',
    'eq.asientos': 'Wyściełane siedzenia',
    'eq.asientosPopa': 'Regulowane siedzenia rufowe',
    'eq.mesa': 'Stół',
    'eq.ducha': 'Prysznic',
    'eq.sonda': 'Echosonda',
    'eq.gps': 'Ploter GPS',
    'eq.camarote': 'Kabina',
    'eq.baño': 'Pełna łazienka',
    'eq.cocina': 'Wyposażona kuchnia',
    'eq.paddle': 'Deska SUP w zestawie',
    'eq.musica': 'System dźwiękowy',
    'eq.plataforma': 'Platforma kąpielowa',
    'eq.radar': 'Radar',
    'eq.piloto': 'Autopilot',
    'eq.helice': 'Ster strumieniowy',
    'eq.molinete': 'Winda kotwiczna',
    'eq.salon': 'Rozkładany salon',
    'eq.banera': 'Kokpit z drewna tekowego',
    'desc.marinello':
      'Żegluj po wybrzeżu Torrevieja bez licencji. Idealne dla rodzin i grup, które chcą całkowitej wolności.',
    'desc.v2':
      'Odkrywaj Morze Śródziemne w komforcie i wolności. Dostępne w Torrevieja i Cabo Roig.',
    'desc.compass':
      'Idealne dla tych, którzy chcą łatwego, wygodnego i bezproblemowego doświadczenia.',
    'desc.calima':
      'Idealne dla par lub małych grup, które chcą cieszyć się morzem we własnym tempie.',
    'desc.marinelloMartin':
      'Wygodny i funkcjonalny klasyk, aby cieszyć się Torrevieja bez licencji.',
    'desc.marinelloNoa':
      'Całkowita wolność żeglowania i cieszenia się Torrevieja z łatwością.',
    'desc.invictus':
      'Moc, komfort i przestrzeń dla grup, które chcą czegoś więcej.',
    'desc.commander':
      'Idealne do odkrywania wybrzeża Alicante z wolnością i stylem. Dotrzyj na wyspę Tabarca.',
    'desc.quicksilver':
      'Przestronny, potężny i idealny na wspaniały dzień na wodzie.',
    'desc.flyer':
      'Bardziej kompletna opcja na długie wycieczki i doświadczenia premium.',
    'desc.prestige':
      'Idealne dla dużych grup, uroczystości i niezapomnianych śródziemnomorskich zachodów słońca.',
    'desc.searay':
      'Doświadczenie premium dla grup, które chcą komfortu, muzyki i najlepszego morza.',
    'desc.noamar':
      'Najbardziej premium doświadczenie w porcie Torrevieja. 14 metrów śródziemnomorskiego luksusu.',
    'desc.nireus':
      'Potężna łódź sportowa z silnikiem 200 KM. Idealna dla grup do 12 osób szukających prędkości i zabawy bez konieczności posiadania licencji.',
    'desc.ranieri':
      'Z 7,8 metra i silnikiem 225 KM, Ranieri oferuje wyjątkową nawigację i ogromne solarium na dziobie, aby cieszyć się słońcem Torrevieja.',
    'desc.smiler':
      'Zwinny i zabawny, Smiler jest idealny dla grup do 8 osób. Jego 115 KM gwarantuje ekscytujące wrażenia na morzu.',
    'boat.badge.licencia': 'licencja',
    'boat.badge.max': 'max',
    'boat.badge.metros': 'metry',
    'boat.badge.motor': 'silnik',
    'jetski.title': 'Skutery wodne w Torrevieja',
    'jetski.subtitle': 'Czysta adrenalina na Morzu Śródziemnym',
    'jetski.desc':
      'Jeśli szukasz prędkości, ekscytacji i zabawy na morzu, skutery wodne są twoją opcją. Dostępne w Torrevieja z wliczonym odprawą bezpieczeństwa. Nie jest wymagana licencja. Wycieczki wolne lub z przewodnikiem w zależności od dostępności.',
    'jetski.f1': 'Nie jest potrzebna licencja',
    'jetski.f2': 'Odprawa bezpieczeństwa wliczona',
    'jetski.f3': 'Nowoczesne skutery wodne',
    'jetski.f4': 'Opcje wolne lub z przewodnikiem',
    'jetski.f5': 'Do 10 mil wybrzeża',
    'jetski.f6': 'Idealne na lato',
    'jetski.note': 'Sprawdź dostępność i cenę przez WhatsApp',
    'jetski.cta': 'Rezerwuj Skuter Wodny',
    'license.title': 'Nie masz licencji? Pomożemy Ci ją zdobyć',
    'license.desc':
      'Kevin Boats również Cię poprowadzi, jeśli chcesz uzyskać licencję żeglarską, aby żeglować z całkowitą wolnością. Uzyskaj dostęp do potężniejszych łodzi i otwórz nowe doświadczenia na morzu. Opowiedz nam o swojej sytuacji, a pomożemy Ci wybrać potrzebną licencję.',
    'license.f1': 'Spersonalizowane wskazówki',
    'license.f2': 'Prosty i szybki proces',
    'license.f3': 'Dostęp do większej liczby łodzi',
    'license.f4': 'Rozszerz swoje opcje na morzu',
    'license.cta': 'Chcę informacji o licencjach',
    'hiw.title': 'Rezerwacja jest bardzo prosta',
    'hiw.s1.title': 'Wybierz swoją łódź',
    'hiw.s1.desc':
      'Przeglądaj katalog i znajdź idealną opcję dla swojej grupy i budżetu.',
    'hiw.s2.title': 'Napisz do nas na WhatsApp',
    'hiw.s2.desc': 'Podaj nam datę, ile was jest i czy masz licencję.',
    'hiw.s3.title': 'Potwierdź i rezerwuj',
    'hiw.s3.desc':
      'Kevin potwierdza dostępność i uzgadniacie wszystkie szczegóły. Żeglujmy!',
    'hiw.cta': 'Zacznij teraz',
    'why.title': 'Dlaczego warto wybrać Kevin Boats?',
    'why.c1.title': 'Bliskie traktowanie',
    'why.c1.desc':
      'Rozmawiasz bezpośrednio z Kevinem. Bez pośredników, bez formularzy.',
    'why.c2.title': 'Znamy Torrevieja',
    'why.c2.desc': 'Prawdziwi miejscowi. Wiemy, gdzie są najlepsze miejsca.',
    'why.c3.title': 'Z licencją i bez',
    'why.c3.desc': 'Opcje dla każdego. Masz licencję czy nie? Mamy twoją łódź.',
    'why.c4.title': 'Natychmiastowa odpowiedź',
    'why.c4.desc': 'Przez WhatsApp potwierdzamy dostępność w kilka minut.',
    'why.c5.title': 'Zróżnicowana flota',
    'why.c5.desc': '13 łodzi dla par, rodzin, grup i na uroczystości.',
    'why.c6.title': 'Pomagamy z licencjami',
    'why.c6.desc': 'Jeśli chcesz zdobyć licencję żeglarską, poprowadzimy Cię.',
    'gallery.title': 'Doświadcz Morza Śródziemnego jak nigdy dotąd',
    'gallery.subtitle': 'Torrevieja · Costa Blanca · Tabarca · Cabo Roig',
    'final.title': 'Gotowy na najlepszy letni dzień?',
    'final.desc':
      'Powiedz nam, ile was jest, jaką masz datę na myśli i czy masz licencję. Kevin znajdzie dla Ciebie idealną łódź w kilka minut.',
    'final.cta.primary': 'Porozmawiaj z Kevinem na WhatsApp',
    'final.cta.secondary': 'Zobacz pełny katalog',
    'contact.title': 'Kontakt',
    'contact.location': 'Torrevieja, Hiszpania',
    'contact.whatsapp': 'Rezerwacje przez WhatsApp',
    'contact.instagram': 'Instagram: @kevin.boats',
    'contact.response': 'Szybka odpowiedź gwarantowana',
    'contact.cta': 'Napisz na WhatsApp',
    'footer.desc': 'Wynajem łodzi i skuterów wodnych',
    'footer.links': 'Szybkie linki',
    'footer.contact': 'Kontakt',
    'footer.rights': 'Wszelkie prawa zastrzeżone',
    'footer.legal': 'Informacje prawne',
    'footer.cookies': 'Polityka Cookies',
    'footer.privacy': 'Polityka Prywatności',
    'footer.terms': 'Regulamin',
    'footer.dataProtection': 'Ochrona Danych',
    'footer.credit': 'Projekt i wykonanie',
    'legal.title': 'Informacje Prawne',
    'legal.close': 'Zamknij',
    'legal.cookies.title': 'Polityka Cookies',
    'legal.cookies.body':
      'Ta strona internetowa wykorzystuje własne pliki cookies oraz pliki cookies stron trzecich w celu poprawy doświadczenia przeglądania, analizy użytkowania strony i personalizacji treści. Cookies to małe pliki tekstowe przechowywane na urządzeniu podczas odwiedzania strony. Możesz w każdej chwili skonfigurować lub odrzucić używanie cookies w ustawieniach przeglądarki. Kontynuując przeglądanie tej strony, akceptujesz używanie cookies zgodnie z tą polityką.',
    'legal.privacy.title': 'Polityka Prywatności',
    'legal.privacy.body':
      'W Kevin Boats szanujemy Twoją prywatność i zobowiązujemy się do ochrony danych osobowych, które nam udostępniasz. Dane zbierane przez WhatsApp lub inny kanał komunikacji są wykorzystywane wyłącznie do zarządzania rezerwacją i odpowiadania na Twoje zapytania. Nie udostępniamy Twoich danych osobom trzecim bez Twojej wyraźnej zgody. Masz prawo dostępu, sprostowania i usunięcia swoich danych osobowych w dowolnym momencie, kontaktując się z nami bezpośrednio.',
    'legal.terms.title': 'Regulamin',
    'legal.terms.body':
      'Wynajem łodzi podlega dostępności i warunkom pogodowym. Klient musi przedstawić ważną dokumentację oraz, w stosownych przypadkach, odpowiednią licencję żeglarską. Kevin Boats zastrzega sobie prawo do anulowania rezerwacji ze względów bezpieczeństwa. Niewłaściwe użytkowanie łodzi może wiązać się z odpowiedzialnością prawną. Wszystkie rezerwacje są zarządzane bezpośrednio przez WhatsApp i potwierdzane za obopólną zgodą.',
    'legal.dataProtection.title': 'Ochrona Danych (RODO)',
    'legal.dataProtection.body':
      'Zgodnie z Rozporządzeniem o Ochronie Danych Osobowych (RODO) UE 2016/679 informujemy, że podane dane osobowe będą traktowane poufnie. Administrator danych: Kevin Boats, Torrevieja, Hiszpania. Cel: zarządzanie rezerwacjami i komunikacja handlowa. Podstawa prawna: zgoda osoby, której dane dotyczą. Prawa: dostęp, sprostowanie, usunięcie, sprzeciw, ograniczenie i przenoszenie danych poprzez kontakt z nami przez WhatsApp.',
    'cookieBanner.text':
      'Używamy plików cookies, aby poprawić jakość przeglądania. Kontynuując, akceptujesz naszą politykę cookies.',
    'cookieBanner.accept': 'Akceptuję',
    'cookieBanner.reject': 'Odrzuć',
    'wa.general':
      'Cześć Kevin 👋\nJestem zainteresowany rezerwacją [BARCO]\nData: [FECHA]\nOsoby: [NÚMERO]\nMam licencję: [SÍ/NO]\nBudżet: [PRESUPUESTO]\nCzy jest dostępna?',
    'wa.jetski':
      'Cześć Kevin 👋\nJestem zainteresowany skuterami wodnymi w Torrevieja.\nData: [FECHA]\nOsoby: [NÚMERO]\nJaka jest cena i dostępność?',
    'wa.license':
      'Cześć Kevin 👋\nJestem zainteresowany informacjami o licencjach żeglarskich.\nCzy możesz mi pomóc?',
    'wa.help':
      'Cześć Kevin, jestem zainteresowany rezerwacją łodzi w Torrevieja. Czy możesz mi pomóc?',
    'wa.premium':
      'Cześć Kevin 👋\nJestem zainteresowany rezerwacją [BARCO].\nData: [FECHA]\nOsoby: [NÚMERO]\nCzas trwania: [4H lub 8H]\nCzy jest dostępna i jaka jest ostateczna cena?',
    'wa.searay':
      'Cześć Kevin 👋 Jestem zainteresowany rezerwacją Sea Ray 290 Sundeck ze skiperem. Czy jest dostępny?',

    // Premium Fleet
    'premium.badge': 'PROFESJONALNY SKIPER W CENIE',
    'premium.title': 'JACHTY PREMIUM',
    'premium.subtitle': 'Ty po prostu ciesz się — kapitan zajmie się wszystkim',
    'premium.description':
      'Dla dużych grup, specjalnych uroczystości i luksusowych doświadczeń na Morzu Śródziemnym. Licencja nie jest wymagana.',
    'premium.captain': 'Z',
    'premium.captainLabel': 'skiper',
    'premium.max': 'max',
    'premium.meters': 'metry',
    'premium.reserve': 'REZERWUJ',
    'premium.price': 'CENA',
    'premium.boat.monaco.desc':
      'Duża łódź premium ze skiperem w cenie. Idealna dla grup szukających komfortu i ekskluzywności.',
    'premium.boat.diamonte.desc':
      'Łódź premium ze skiperem w cenie. Idealna dla grup szukających komfortu i ekskluzywności na Morzu Śródziemnym.',
    'premium.boat.lagoon.desc':
      'Luksusowy katamaran nowej generacji. Łączy styl i funkcjonalność dla doświadczenia premium na Morzu Śródziemnym.',
    'premium.boat.lagoon.note': '+ paliwo nie jest wliczone',
    'premium.boat.prestige.desc':
      'Jacht premium z 2 kajutami, salonem i kuchnią. Profesjonalny skiper w cenie dla maksymalnie 12 osób.',
    'premium.boat.prestige.note': '2 kajuty · Salon · Kuchnia',
    'premium.boat.puravida.desc':
      'Najbardziej ekskluzywny katamaran we flocie Kevin Boats. 15 metrów czystego śródziemnomorskiego luksusu z profesjonalnym kapitanem w cenie. Najlepsze doświadczenie w Torrevieja.',
    'premium.boat.puravida.badge': 'DOŚWIADCZENIE PREMIUM',
    'premium.boat.nireus.desc':
      'Potężna i przestronna 6-metrowa łódź, idealna dla grup do 12 osób szukających prędkości i komfortu z profesjonalnym skiperem.',
    'premium.aria.prev': 'Poprzednie zdjęcie',
    'premium.aria.next': 'Następne zdjęcie',
    'premium.aria.zoom': 'Powiększ zdjęcie',
    'premium.aria.close': 'Zamknij',

    // Jet Ski Tours
    'jetski.tour.badge': 'BEZ WYMAGANEJ LICENCJI',
    'jetski.tour.title': 'SKUTERY WODNE\nW TORREVIEJA',
    'jetski.tour.subtitle': 'Czysta adrenalina na Morzu Śródziemnym',
    'jetski.tour.f1': 'Bez wymaganej licencji',
    'jetski.tour.f2': '5 dostępnych tras',
    'jetski.tour.f3': 'Odprawa bezpieczeństwa w cenie',
    'jetski.tour.f4': 'Wypłynięcie z Torrevieja',
    'jetski.tour.1.name': 'PLAŻE',
    'jetski.tour.1.desc':
      'Zwiedź najpiękniejsze plaże Torrevieja. Idealne na początek.',
    'jetski.tour.2.name': 'ZATOCZKI',
    'jetski.tour.2.desc':
      'Odkryj tajne zatoczki Costa Blanca. Krystalicznie czysta woda gwarantowana.',
    'jetski.tour.3.name': 'CABO ROIG',
    'jetski.tour.3.desc':
      'Popłyń do Cabo Roig i ciesz się najbardziej spektakularnymi widokami na wybrzeże.',
    'jetski.tour.4.name': 'AGUAMARINA',
    'jetski.tour.4.desc':
      'Przedłużona trasa do Aguamarina. Swobodna nawigacja po najlepszych zatoczkach Costa Blanca.',
    'jetski.tour.5.name': 'TABARCA / ISLA GROSA',
    'jetski.tour.5.desc':
      'Największa przygoda. Dotrzyj na wyspę Tabarca lub Isla Grosa. Obiad w porcie w cenie.',
    'jetski.tour.5.includes': '⭐ Obiad w Proamar Puerto',
    'jetski.card.min': 'MIN.',
    'jetski.card.from': 'OD',
    'jetski.card.price': 'CENA',
    'jetski.card.premium': 'PREMIUM',
    'jetski.cta.title': 'ZAREZERWUJ WYCIECZKĘ!',
    'jetski.cta.subtitle': 'Potwierdzenie w kilka minut przez WhatsApp',
    'jetski.cta.desc':
      'Napisz do nas na WhatsApp, a potwierdzimy dostępność w kilka minut',
    'jetski.cta.btn': 'REZERWUJ PRZEZ WHATSAPP',

    'reviews.title': 'Co mówią nasi klienci',
    'reviews.subtitle': 'Prawdziwe doświadczenia na Morzu Śródziemnym',
    'reviews.1.text':
      'Niesamowite doświadczenie. Kevin odpowiedział na WhatsAppie w kilka minut, wszystko jasne, łódź nieskazitelna. Na pewno wrócimy następnego lata.',
    'reviews.1.author': 'Carlos & Andrea',
    'reviews.1.location': 'Madryt',
    'reviews.2.text':
      'Wynajęliśmy Prestige 34 na urodziny mojej żony i było spektakularnie. Zachód słońca nad Torrevieja, muzyka, paddle… idealny dzień.',
    'reviews.2.author': 'Javier M.',
    'reviews.2.location': 'Walencja',
    'reviews.3.text':
      'Bez licencji i bez komplikacji. Marinello jest idealne dla rodziny z dziećmi. Osobiste podejście i uczciwa cena. Polecam.',
    'reviews.3.author': 'Rodzina Rodríguez',
    'reviews.3.location': 'Alicante',
    'reviews.4.text':
      'Dotarliśmy do Tabarki łodzią Commander. Turkusowa woda jest niesamowita. Kevin dał nam wszystkie wskazówki, by maksymalnie wykorzystać dzień.',
    'reviews.4.author': 'Sophie L.',
    'reviews.4.location': 'Lyon, Francja',
    'reviews.5.text':
      'Skuter wodny to czysta adrenalina. Szybkie szkolenie, nowy sprzęt i pełna swoboda. Wspaniale.',
    'reviews.5.author': 'Tomek W.',
    'reviews.5.location': 'Warszawa, Polska',
  },
  de: {
    'nav.home': 'Startseite',
    'nav.boats': 'Boote',
    'nav.premium': 'Premium-Yachten',
    'nav.jetski': 'Jet-Skis',
    'nav.licenses': 'Lizenzen',
    'nav.howItWorks': 'Wie es funktioniert',
    'nav.gallery': 'Galerie',
    'nav.reviews': 'Bewertungen',
    'nav.contact': 'Kontakt',
    'header.tagline': 'Torrevieja · Bootsverleih',
    'header.reserve': 'Über WhatsApp buchen',
    'hero.headline':
      'Mieten Sie Ihr Boot in Torrevieja und erleben Sie den besten Sommertag',
    'hero.subheadline':
      'Boote mit und ohne Führerschein, Jet-Skis und Premium-Erlebnisse im Mittelmeer. Einfache Buchung über WhatsApp in Minuten.',
    'hero.cta.primary': 'Verfügbare Boote ansehen',
    'hero.cta.secondary': 'Über WhatsApp buchen',
    'hero.trust.1': 'Kein Warenkorb oder Online-Zahlung',
    'hero.trust.2': 'Sofortige Antwort',
    'hero.trust.3': 'Mit und ohne Führerschein',
    'hero.trust.4': 'Torrevieja · Costa Blanca',
    'trustbar.1': '13 Boote verfügbar',
    'trustbar.2': 'Abfahrten ab Torrevieja',
    'trustbar.3': 'Schnelle Buchung über WhatsApp',
    'trustbar.4': 'Erlebnisse für alle Niveaus',
    'quiz.title': 'Finden Sie Ihr ideales Boot',
    'quiz.subtitle':
      'Beantworten Sie 4 Fragen und wir empfehlen die beste Option',
    'quiz.q1': 'Wie viele Personen sind Sie?',
    'quiz.q1.o1': '1 bis 4 Personen',
    'quiz.q1.o2': '5 bis 6 Personen',
    'quiz.q1.o3': '7 bis 8 Personen',
    'quiz.q1.o4': '9 bis 12 Personen',
    'quiz.q2': 'Haben Sie einen Bootsführerschein?',
    'quiz.q2.o1': 'Ja, ich habe einen Führerschein',
    'quiz.q2.o2': 'Nein, ich habe keinen Führerschein',
    'quiz.q2.o3': 'Ich möchte einen Führerschein machen',
    'quiz.q3': 'Welches Erlebnis suchen Sie?',
    'quiz.q3.o1': 'Nur ein Boot',
    'quiz.q3.o2': 'Boot + Jet-Ski',
    'quiz.q3.o3': 'Nur Jet-Ski',
    'quiz.q3.o4': 'Überraschen Sie mich',
    'quiz.q4': 'Wie hoch ist Ihr Budget?',
    'quiz.q4.o1': 'Bis zu 150€',
    'quiz.q4.o2': 'Zwischen 150€ und 300€',
    'quiz.q4.o3': 'Zwischen 300€ und 500€',
    'quiz.q4.o4': 'Mehr als 500€',
    'quiz.result.title': 'Ihre ideale Option',
    'quiz.result.cta': 'Diese Option über WhatsApp buchen',
    'quiz.result.from': 'Ab',
    'quiz.reset': 'Von vorne anfangen',
    'fleet.title': 'Unsere Flotte in Torrevieja',
    'fleet.filter.all': 'Alle',
    'fleet.filter.noLicense': 'Ohne Führerschein',
    'fleet.filter.license': 'Mit Führerschein',
    'fleet.filter.premium': 'Premium mit Skipper',
    'boat.capacity': 'Kapazität',
    'boat.license': 'Führerschein',
    'boat.location': 'Standort',
    'boat.engine': 'Motor',
    'boat.length': 'Länge',
    'boat.price.from': 'Ab',
    'boat.price.lowSeason': 'Nebensaison (Nov-Mär)',
    'boat.price.highSeason': 'Hauptsaison (Apr-Okt)',
    'boat.price.allYear': 'Ganzjährig',
    'boat.price.hour': 'Stunde',
    'boat.price.hours': 'Stunden',
    'boat.price.halfDay': 'Halber Tag',
    'boat.price.fullDay': 'Ganzer Tag',
    'boat.price.sunset': 'Sonnenuntergang 2 Stunden',
    'boat.note.fuel': '⚠️ Kraftstoff nicht inbegriffen',
    'boat.note.highSeason': '⚠️ Hauptsaisonpreise',
    'boat.note.skipperFuel': '⚠️ Skipper und Kraftstoff nicht inbegriffen',
    'boat.cta': 'Über WhatsApp buchen',
    'boat.banner.licenseReq': 'FÜHRERSCHEIN ERFORDERLICH',
    'boat.banner.noLicense': 'OHNE FÜHRERSCHEIN',
    'boat.banner.licenseSkipper': 'FÜHRERSCHEIN ERFORDERLICH · SKIPPER +20€/H',
    'boat.banner.licensePNBSkipper':
      'PNB-FÜHRERSCHEIN ERFORDERLICH · SKIPPER +20€/H',
    'boat.banner.skipperIncluded': 'SKIPPER INKLUSIVE',
    'boat.spec.peopleMax': 'PERSONEN MAX',
    'boat.spec.length': 'METER LÄNGE',
    'boat.duration.2h': '2 STUNDEN',
    'boat.duration.4h': '4 STUNDEN',
    'boat.duration.8h': '8 STUNDEN',
    'boat.duration.halfDay': 'HALBER TAG',
    'boat.duration.fullDay': 'GANZER TAG',
    'boat.durationInfo': 'Halber Tag = 4h · Ganzer Tag = 8h',
    'boat.specLines.searay.peopleSkipper': '11 PERSONEN + SKIPPER',
    'boat.specLines.searay.paddleIncluded': 'PADDLEBOARD INKLUSIVE',
    'boat.specLines.prestige.people': '12 PERSONEN + SKIPPER',
    'boat.specLines.prestige.features': '2 KABINEN · SALON · KÜCHE',
    'eq.solarium': 'Sonnenliege',
    'eq.solariumProa': 'Bug-Sonnenliege',
    'eq.solariumPopa': 'Heck-Sonnenliege',
    'eq.toldo': 'Bimini-Verdeck',
    'eq.toldoGran': 'Großes Vorzelt',
    'eq.radio': 'Bluetooth-Radio',
    'eq.nevera': 'Kühlbox mit Eis',
    'eq.escalera': 'Badeleiter',
    'eq.asientos': 'Gepolsterte Sitze',
    'eq.asientosPopa': 'Verstellbare Hecksitze',
    'eq.mesa': 'Tisch',
    'eq.ducha': 'Dusche',
    'eq.sonda': 'Echolot',
    'eq.gps': 'GPS-Plotter',
    'eq.camarote': 'Kabine',
    'eq.baño': 'Komplettes Badezimmer',
    'eq.cocina': 'Ausgestattete Küche',
    'eq.paddle': 'Paddle-Surf inklusive',
    'eq.musica': 'Soundsystem',
    'eq.plataforma': 'Badeplattform',
    'eq.radar': 'Radar',
    'eq.piloto': 'Autopilot',
    'eq.helice': 'Bugstrahlruder',
    'eq.molinete': 'Elektrische Ankerwinde',
    'eq.salon': 'Umbaubarer Salon',
    'eq.banera': 'Teakholz-Cockpit',
    'desc.marinello':
      'Segeln Sie ohne Führerschein an der Küste von Torrevieja. Perfekt für Familien und Gruppen, die völlige Freiheit wollen.',
    'desc.v2':
      'Erkunden Sie das Mittelmeer mit Komfort und Freiheit. Verfügbar in Torrevieja und Cabo Roig.',
    'desc.compass':
      'Ideal für diejenigen, die ein einfaches, komfortables und problemloses Erlebnis wünschen.',
    'desc.calima':
      'Perfekt für Paare oder kleine Gruppen, die das Meer in ihrem eigenen Tempo genießen möchten.',
    'desc.marinelloMartin':
      'Ein komfortabler und funktionaler Klassiker, um Torrevieja ohne Führerschein zu genießen.',
    'desc.marinelloNoa':
      'Völlige Freiheit, um Torrevieja einfach zu besegeln und zu genießen.',
    'desc.invictus':
      'Leistung, Komfort und Platz für Gruppen, die etwas mehr wollen.',
    'desc.commander':
      'Ideal, um die Küste von Alicante mit Freiheit und Stil zu erkunden. Erreichen Sie die Insel Tabarca.',
    'desc.quicksilver':
      'Geräumig, leistungsstark und perfekt für einen tollen Tag auf dem Wasser.',
    'desc.flyer':
      'Eine komplettere Option für lange Ausflüge und Premium-Erlebnisse.',
    'desc.prestige':
      'Perfekt für große Gruppen, Feiern und unvergessliche mediterrane Sonnenuntergänge.',
    'desc.searay':
      'Ein Premium-Erlebnis für Gruppen, die Komfort, Musik und das beste Meer wollen.',
    'desc.noamar':
      'Das hochwertigste Erlebnis im Hafen von Torrevieja. 14 Meter mediterraner Luxus.',
    'desc.nireus':
      'Leistungsstarkes Sportboot mit 200 PS Motor. Ideal für Gruppen von bis zu 12 Personen, die Geschwindigkeit und Spaß ohne Führerschein suchen.',
    'desc.ranieri':
      'Mit 7,8 Metern und einem 225 PS Motor bietet die Ranieri eine außergewöhnliche Navigation und ein riesiges Bug-Solarium, um die Sonne von Torrevieja zu genießen.',
    'desc.smiler':
      'Wendig und spaßig, die Smiler ist perfekt für Gruppen von bis zu 8 Personen. Ihre 115 PS garantieren ein aufregendes Erlebnis auf See.',
    'boat.badge.licencia': 'führerschein',
    'boat.badge.max': 'max',
    'boat.badge.metros': 'meter',
    'boat.badge.motor': 'motor',
    'jetski.title': 'Jet-Skis in Torrevieja',
    'jetski.subtitle': 'Pures Adrenalin im Mittelmeer',
    'jetski.desc':
      'Wenn Sie Geschwindigkeit, Spannung und Spaß auf dem Meer suchen, sind Jet-Skis Ihre Option. Verfügbar in Torrevieja mit Sicherheitseinweisung inklusive. Kein Führerschein erforderlich. Freie oder geführte Ausflüge je nach Verfügbarkeit.',
    'jetski.f1': 'Kein Führerschein erforderlich',
    'jetski.f2': 'Sicherheitseinweisung inklusive',
    'jetski.f3': 'Moderne Jet-Skis',
    'jetski.f4': 'Freie oder geführte Optionen',
    'jetski.f5': 'Bis zu 10 Meilen Küste',
    'jetski.f6': 'Perfekt für den Sommer',
    'jetski.note': 'Verfügbarkeit und Preis über WhatsApp prüfen',
    'jetski.cta': 'Jet-Ski buchen',
    'license.title':
      'Sie haben keinen Führerschein? Wir helfen Ihnen, ihn zu bekommen',
    'license.desc':
      'Kevin Boats berät Sie auch, wenn Sie Ihren Bootsführerschein erwerben möchten, um mit völliger Freiheit zu segeln. Greifen Sie auf leistungsstärkere Boote zu und eröffnen Sie sich neue Erlebnisse auf See. Erzählen Sie uns von Ihrer Situation und wir helfen Ihnen bei der Auswahl des benötigten Führerscheins.',
    'license.f1': 'Persönliche Beratung',
    'license.f2': 'Einfacher und schneller Prozess',
    'license.f3': 'Zugang zu mehr Booten',
    'license.f4': 'Erweitern Sie Ihre Optionen auf See',
    'license.cta': 'Ich möchte Informationen zu Lizenzen',
    'hiw.title': 'Buchen ist ganz einfach',
    'hiw.s1.title': 'Wählen Sie Ihr Boot',
    'hiw.s1.desc':
      'Erkunden Sie den Katalog und finden Sie die perfekte Option für Ihre Gruppe und Ihr Budget.',
    'hiw.s2.title': 'Schreiben Sie uns auf WhatsApp',
    'hiw.s2.desc':
      'Teilen Sie uns das Datum mit, wie viele Personen Sie sind und ob Sie einen Führerschein haben.',
    'hiw.s3.title': 'Bestätigen und buchen',
    'hiw.s3.desc':
      'Kevin bestätigt die Verfügbarkeit und Sie vereinbaren alle Details. Lassen Sie uns segeln!',
    'hiw.cta': 'Jetzt starten',
    'why.title': 'Warum Kevin Boats wählen?',
    'why.c1.title': 'Persönliche Betreuung',
    'why.c1.desc':
      'Sie sprechen direkt mit Kevin. Keine Vermittler, keine Formulare.',
    'why.c2.title': 'Wir kennen Torrevieja',
    'why.c2.desc': 'Echte Einheimische. Wir wissen, wo die besten Orte sind.',
    'why.c3.title': 'Mit und ohne Führerschein',
    'why.c3.desc':
      'Optionen für alle. Haben Sie einen Führerschein oder nicht? Wir haben Ihr Boot.',
    'why.c4.title': 'Sofortige Antwort',
    'why.c4.desc': 'Über WhatsApp bestätigen wir die Verfügbarkeit in Minuten.',
    'why.c5.title': 'Abwechslungsreiche Flotte',
    'why.c5.desc': '13 Boote für Paare, Familien, Gruppen und Feiern.',
    'why.c6.title': 'Wir helfen bei Lizenzen',
    'why.c6.desc':
      'Wenn Sie Ihren Bootsführerschein machen möchten, beraten wir Sie.',
    'gallery.title': 'Erleben Sie das Mittelmeer wie nie zuvor',
    'gallery.subtitle': 'Torrevieja · Costa Blanca · Tabarca · Cabo Roig',
    'final.title': 'Bereit für den besten Sommertag?',
    'final.desc':
      'Sagen Sie uns, wie viele Personen Sie sind, welches Datum Sie im Sinn haben und ob Sie einen Führerschein haben. Kevin findet in Minuten das perfekte Boot für Sie.',
    'final.cta.primary': 'Mit Kevin auf WhatsApp sprechen',
    'final.cta.secondary': 'Gesamten Katalog ansehen',
    'contact.title': 'Kontakt',
    'contact.location': 'Torrevieja, Spanien',
    'contact.whatsapp': 'Buchungen über WhatsApp',
    'contact.instagram': 'Instagram: @kevin.boats',
    'contact.response': 'Schnelle Antwort garantiert',
    'contact.cta': 'Auf WhatsApp schreiben',
    'footer.desc': 'Boots- und Jet-Ski-Verleih',
    'footer.links': 'Schnelle Links',
    'footer.contact': 'Kontakt',
    'footer.rights': 'Alle Rechte vorbehalten',
    'footer.legal': 'Rechtliches',
    'footer.cookies': 'Cookie-Richtlinie',
    'footer.privacy': 'Datenschutzerklärung',
    'footer.terms': 'AGB',
    'footer.dataProtection': 'Datenschutz',
    'footer.credit': 'Design & Entwicklung von',
    'legal.title': 'Rechtliche Informationen',
    'legal.close': 'Schließen',
    'legal.cookies.title': 'Cookie-Richtlinie',
    'legal.cookies.body':
      'Diese Website verwendet eigene Cookies und Cookies von Drittanbietern, um Ihre Browser-Erfahrung zu verbessern, die Nutzung der Website zu analysieren und Inhalte zu personalisieren. Cookies sind kleine Textdateien, die beim Besuch der Website auf Ihrem Gerät gespeichert werden. Sie können die Verwendung von Cookies jederzeit über Ihre Browser-Einstellungen konfigurieren oder ablehnen. Durch die fortgesetzte Nutzung dieser Website akzeptieren Sie die Verwendung von Cookies wie in dieser Richtlinie beschrieben.',
    'legal.privacy.title': 'Datenschutzerklärung',
    'legal.privacy.body':
      'Bei Kevin Boats respektieren wir Ihre Privatsphäre und verpflichten uns, die personenbezogenen Daten, die Sie mit uns teilen, zu schützen. Über WhatsApp oder andere Kommunikationskanäle erhobene Daten werden ausschließlich zur Verwaltung Ihrer Buchung und zur Beantwortung Ihrer Anfragen verwendet. Wir geben Ihre Daten ohne Ihre ausdrückliche Zustimmung nicht an Dritte weiter. Sie haben jederzeit das Recht auf Zugang, Berichtigung und Löschung Ihrer personenbezogenen Daten, indem Sie uns direkt kontaktieren.',
    'legal.terms.title': 'AGB',
    'legal.terms.body':
      'Die Bootsmiete unterliegt der Verfügbarkeit und den Wetterbedingungen. Der Kunde muss gültige Dokumente und gegebenenfalls den entsprechenden Bootsführerschein vorlegen. Kevin Boats behält sich das Recht vor, die Buchung aus Sicherheitsgründen zu stornieren. Eine unsachgemäße Verwendung der Boote kann zu rechtlicher Haftung führen. Alle Buchungen werden direkt über WhatsApp verwaltet und in gegenseitigem Einvernehmen bestätigt.',
    'legal.dataProtection.title': 'Datenschutz (DSGVO)',
    'legal.dataProtection.body':
      'Gemäß der Datenschutz-Grundverordnung (DSGVO) EU 2016/679 informieren wir Sie, dass die bereitgestellten personenbezogenen Daten vertraulich behandelt werden. Verantwortlicher: Kevin Boats, Torrevieja, Spanien. Zweck: Buchungsverwaltung und kommerzielle Kommunikation. Rechtsgrundlage: Einwilligung des Betroffenen. Rechte: Zugang, Berichtigung, Löschung, Widerspruch, Einschränkung und Übertragbarkeit der Daten durch Kontaktaufnahme über WhatsApp.',
    'cookieBanner.text':
      'Wir verwenden Cookies, um Ihr Surf-Erlebnis zu verbessern. Durch die weitere Nutzung akzeptieren Sie unsere Cookie-Richtlinie.',
    'cookieBanner.accept': 'Akzeptieren',
    'cookieBanner.reject': 'Ablehnen',
    'wa.general':
      'Hallo Kevin 👋\nIch bin an der Buchung von [BARCO] interessiert\nDatum: [FECHA]\nPersonen: [NÚMERO]\nIch habe einen Führerschein: [SÍ/NO]\nBudget: [PRESUPUESTO]\nIst es verfügbar?',
    'wa.jetski':
      'Hallo Kevin 👋\nIch interessiere mich für Jet-Skis in Torrevieja.\nDatum: [FECHA]\nPersonen: [NÚMERO]\nWie ist der Preis und die Verfügbarkeit?',
    'wa.license':
      'Hallo Kevin 👋\nIch interessiere mich für Informationen zu Bootsführerscheinen.\nKönnen Sie mich beraten?',
    'wa.help':
      'Hallo Kevin, ich bin an der Buchung eines Bootes in Torrevieja interessiert. Können Sie mir helfen?',
    'wa.premium':
      'Hallo Kevin 👋\nIch bin an der Buchung von [BARCO] interessiert.\nDatum: [FECHA]\nPersonen: [NÚMERO]\nDauer: [4H oder 8H]\nIst es verfügbar und was ist der Endpreis?',
    'wa.searay':
      'Hallo Kevin 👋 Ich interessiere mich für die Buchung des Sea Ray 290 Sundeck mit Skipper. Ist er verfügbar?',

    // Premium Fleet
    'premium.badge': 'PROFESSIONELLER SKIPPER INKLUSIVE',
    'premium.title': 'PREMIUM-YACHTEN',
    'premium.subtitle':
      'Sie genießen einfach — der Kapitän kümmert sich um alles',
    'premium.description':
      'Für große Gruppen, besondere Feiern und Luxuserlebnisse im Mittelmeer. Kein Führerschein erforderlich.',
    'premium.captain': 'MIT',
    'premium.captainLabel': 'skipper',
    'premium.max': 'max',
    'premium.meters': 'meter',
    'premium.reserve': 'BUCHEN',
    'premium.price': 'PREIS',
    'premium.boat.monaco.desc':
      'Großformatiges Premium-Boot mit Skipper inklusive. Perfekt für Gruppen, die Komfort und Exklusivität suchen.',
    'premium.boat.diamonte.desc':
      'Premium-Boot mit Skipper inklusive. Perfekt für Gruppen, die Komfort und Exklusivität im Mittelmeer suchen.',
    'premium.boat.lagoon.desc':
      'Luxus-Katamaran der neuesten Generation. Kombiniert Stil und Funktionalität für ein Premium-Erlebnis im Mittelmeer.',
    'premium.boat.lagoon.note': '+ Kraftstoff nicht inbegriffen',
    'premium.boat.prestige.desc':
      'Premium-Yacht mit 2 Kabinen, Salon und Küche. Professioneller Skipper inklusive für bis zu 12 Personen.',
    'premium.boat.prestige.note': '2 Kabinen · Salon · Küche',
    'premium.boat.puravida.desc':
      'Der exklusivste Katamaran in der Kevin Boats Flotte. 15 Meter purer mediterraner Luxus mit professionellem Kapitän inklusive. Das ultimative Erlebnis in Torrevieja.',
    'premium.boat.puravida.badge': 'PREMIUM ERLEBNIS',
    'premium.boat.nireus.desc':
      'Leistungsstarkes und geräumiges 6-Meter-Boot, ideal für Gruppen von bis zu 12 Personen, die Geschwindigkeit und Komfort mit einem professionellen Skipper suchen.',
    'premium.aria.prev': 'Vorheriges Foto',
    'premium.aria.next': 'Nächstes Foto',
    'premium.aria.zoom': 'Foto vergrößern',
    'premium.aria.close': 'Schließen',

    // Jet Ski Tours
    'jetski.tour.badge': 'KEIN FÜHRERSCHEIN ERFORDERLICH',
    'jetski.tour.title': 'JET-SKIS\nIN TORREVIEJA',
    'jetski.tour.subtitle': 'Pures Adrenalin im Mittelmeer',
    'jetski.tour.f1': 'Kein Führerschein erforderlich',
    'jetski.tour.f2': '5 Routen verfügbar',
    'jetski.tour.f3': 'Sicherheitseinweisung inklusive',
    'jetski.tour.f4': 'Abfahrt von Torrevieja',
    'jetski.tour.1.name': 'DIE STRÄNDE',
    'jetski.tour.1.desc':
      'Erkunden Sie die schönsten Strände von Torrevieja. Perfekt für den Anfang.',
    'jetski.tour.2.name': 'DIE BUCHTEN',
    'jetski.tour.2.desc':
      'Entdecken Sie die geheimen Buchten der Costa Blanca. Kristallklares Wasser garantiert.',
    'jetski.tour.3.name': 'CABO ROIG',
    'jetski.tour.3.desc':
      'Segeln Sie nach Cabo Roig und genießen Sie die spektakulärsten Ausblicke auf die Küste.',
    'jetski.tour.4.name': 'AGUAMARINA',
    'jetski.tour.4.desc':
      'Erweiterte Route nach Aguamarina. Freie Navigation durch die besten Buchten der Costa Blanca.',
    'jetski.tour.5.name': 'TABARCA / ISLA GROSA',
    'jetski.tour.5.desc':
      'Das ultimative Abenteuer. Erreichen Sie die Insel Tabarca oder Isla Grosa. Mittagessen im Hafen inklusive.',
    'jetski.tour.5.includes': '⭐ Mittagessen in Proamar Puerto',
    'jetski.card.min': 'MIN.',
    'jetski.card.from': 'AB',
    'jetski.card.price': 'PREIS',
    'jetski.card.premium': 'PREMIUM',
    'jetski.cta.title': 'BUCHEN SIE IHRE TOUR!',
    'jetski.cta.subtitle': 'Bestätigung in Minuten per WhatsApp',
    'jetski.cta.desc':
      'Schreiben Sie uns auf WhatsApp und wir bestätigen die Verfügbarkeit in Minuten',
    'jetski.cta.btn': 'ÜBER WHATSAPP BUCHEN',

    'reviews.title': 'Was unsere Kunden sagen',
    'reviews.subtitle': 'Echte Erlebnisse im Mittelmeer',
    'reviews.1.text':
      'Ein unglaubliches Erlebnis. Kevin antwortete in Minuten auf WhatsApp, alles super klar und das Boot makellos. Wir kommen nächsten Sommer ganz sicher wieder.',
    'reviews.1.author': 'Carlos & Andrea',
    'reviews.1.location': 'Madrid',
    'reviews.2.text':
      'Wir mieteten die Prestige 34 zum Geburtstag meiner Frau und es war spektakulär. Sonnenuntergang über Torrevieja, Musik, Paddle… ein perfekter Tag.',
    'reviews.2.author': 'Javier M.',
    'reviews.2.location': 'Valencia',
    'reviews.3.text':
      'Ohne Führerschein und ohne Stress. Die Marinello ist perfekt für eine Familie mit Kindern. Persönlicher Service und fairer Preis. Sehr empfehlenswert.',
    'reviews.3.author': 'Familie Rodríguez',
    'reviews.3.location': 'Alicante',
    'reviews.4.text':
      'Wir fuhren mit dem Commander nach Tabarca. Das türkisfarbene Wasser ist einzigartig. Kevin gab uns alle Tipps für einen perfekten Tag.',
    'reviews.4.author': 'Sophie L.',
    'reviews.4.location': 'Lyon, Frankreich',
    'reviews.5.text':
      'Das Jet-Ski war reine Adrenalin. Schnelles Briefing, brandneue Ausrüstung und totale Freiheit. Großartig.',
    'reviews.5.author': 'Tomek W.',
    'reviews.5.location': 'Warschau, Polen',
  },
}
